<template>
  <!-- 90% global scale wrapper -->
  <div class="ui-scale" :class="{ 'dashboard--dark': $vuetify.theme.dark }" :style="scaleStyle">
    <div style="margin-bottom: 8px; display: flex; align-items: center; justify-content: flex-end; padding-right: 20px; gap: 16px;">
      <span class="study-year-title">O'QUV YILI: {{ selectedStudyYear }}</span>
      <v-btn
          class="filter-btn"
          elevation="0"
          large
          rounded
          @click="showFilters = !showFilters"
      >
        <img src="../../assets/filter.svg" alt="Filter Icon" style="margin-right: 8px;">
      </v-btn>
    </div>

    <v-fade-transition>
      <v-container v-if="showFilters" fluid>
        <div class="filter-row">
          <v-menu
              ref="studyYearWrapper"
              v-model="studyYearMenu"
              :close-on-content-click="true"
              offset-y
              transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{ selectedStudyYear || "O'QUV YILI" }}
              </v-btn>
            </template>

            <v-card :style="{
              maxWidth: '274px',
              maxHeight: '400px',
              backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
            }">
              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="year in studyYearOptions"
                      :key="year"
                      :label="year"
                      :input-value="selectedStudyYear === year"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="onStudyYearSelect(year)"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="studyYearMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="roleWrapper"
              v-model="roleMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedRole.length
                      ? (() => {
                        const names = role
                            .filter(f => selectedRole.includes(f.id))
                            .map(f => f.name);
                        if (names.length === 1) return names[0];
                        if (names.length > 1) {
                          const first = names[0];
                          return `${first}, ..`;
                        }
                        return $t("O'QUV TURI");
                      })()
                      : $t("O'QUV TURI")
                }}
              </v-btn>
            </template>

            <v-card
                :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                    v-model="searchRole"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredRole"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      v-model="selectedRole"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="roleMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="menuWrapper"
              v-model="menu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">{{ selected.toString() || $t("bosqich").toUpperCase() }}</v-btn>
            </template>

            <v-card :style="{
              maxWidth: '274px',
              backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              height: 'max-content',
              zIndex: 1000
            }">
              <v-card-title>
                <v-text-field
                    v-model="search"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      v-model="selected"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="onBosqichChange(item)"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="menu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="educationFacultyWrapper"
              v-model="educationFacultyMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  class="button-primary"
                  v-bind="attrs"
                  v-on="on"
                  style="max-width: 274px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{
                  selectedEducationFaculty.length
                      ? (() => {
                        const names = educationFaculty
                            .filter(f => selectedEducationFaculty.includes(f.id))
                            .map(f => f.name);
                        if (names.length === 1) return names[0];
                        if (names.length > 1) {
                          const first = names[0];
                          return `${first}, ..`;
                        }
                        return $t("TA'LIM YO'NALISHI");
                      })()
                      : $t("TA'LIM YO'NALISHI")
                }}
              </v-btn>
            </template>

            <v-card :style="{
              maxWidth: '274px',
              maxHeight: '400px',
              backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
            }">
              <v-card-title>
                <v-text-field
                    v-model="searchEducationFaculty"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredEducationFaculty"
                      :key="item.id"
                      :label="item.name + ' - ' + item.mvdir"

                      :value="item.id"
                      v-model="selectedEducationFaculty"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="menu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="educationTypeWrapper"
              v-model="educationTypeMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedEducationType.length
                      ? (() => {
                        const names = educationType
                            .filter(f => selectedEducationType.includes(f.id))
                            .map(f => f.name);
                        if (names.length === 1) return names[0];
                        if (names.length > 1) {
                          const first = names[0];
                          return `${first}, ..`;
                        }
                        return $t("TA'LIM SHAKLI");
                      })()
                      : $t("TA'LIM SHAKLI")
                }}
              </v-btn>
            </template>

            <v-card
                :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                    v-model="searchEducationType"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredEducationType"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      v-model="selectedEducationType"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="educationTypeMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="educationLanguageWrapper"
              v-model="educationLanguageMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedEducationLanguage.length
                      ? educationLanguage
                          .filter((f) => selectedEducationLanguage.includes(f.id))
                          .map((f) => f.name)
                          .join(', ')
                      : $t("TA'LIM TILI")
                }}
              </v-btn>
            </template>

            <v-card
                :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                    v-model="searchEducationLanguage"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredEducationLanguage"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      v-model="selectedEducationLanguage"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="educationLanguageMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="groupWrapper"
              v-model="groupMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedGroup.length
                      ? (() => {
                        const names = group
                            .filter(f => selectedGroup.includes(f.name))
                            .map(f => f.name);
                        if (names.length === 1) return names[0];
                        if (names.length > 1) {
                          const first = names[0];
                          return `${first}, ..`;
                        }
                        return $t("GURUH");
                      })()
                      : $t("GURUH")
                }}
              </v-btn>
            </template>

            <v-card
                :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                    v-model="searchGroup"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredGroup"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                      v-model="selectedGroup"
                      @change="onGroupChange(item)"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="groupMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="regionWrapper"
              v-model="regionMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedRegion.length
                      ? (() => {
                        const names = region
                            .filter(f => selectedRegion.includes(f.id))
                            .map(f => f.name);
                        if (names.length === 1) return names[0];
                        if (names.length > 1) {
                          const first = names[0];
                          return `${first}, ..`;
                        }
                        return $t("VILOYAT");
                      })()
                      : $t("VILOYAT")
                }}
              </v-btn>
            </template>

            <v-card
                :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                    v-model="searchRegion"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredRegion"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      v-model="selectedRegion"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="onRegionChange(item, $event)"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="regionMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="districtWrapper"
              v-model="districtMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedDistrict.length
                      ? (() => {
                        const names = district
                            .filter(f => selectedDistrict.includes(f.id))
                            .map(f => f.name);
                        if (names.length === 1) return names[0];
                        if (names.length > 1) {
                          const first = names[0];
                          return `${first}, ..`;
                        }
                        return $t("TUMAN");
                      })()
                      : $t("TUMAN")
                }}
              </v-btn>
            </template>

            <v-card
                :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                    v-model="searchDistrict"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredDistrict"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      v-model="selectedDistrict"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="onDistrictChange(item)"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="districtMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="genderWrapper"
              v-model="genderMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedGender.length
                      ? gender
                          .filter((f) => selectedGender.includes(f.id))
                          .map((f) => f.name)
                          .join(', ')
                      : $t("JINS")
                }}
              </v-btn>
            </template>

            <v-card
                :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                    v-model="searchGender"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredGender"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      v-model="selectedGender"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="genderMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="discountWrapper"
              v-model="discountMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedDiscount.length
                      ? (() => {
                        const names = discount
                            .filter(f => selectedDiscount.includes(f.id))
                            .map(f => f.isPercent ? `${f.promotion}%` : `${f.promotion} so'm`);
                        if (names.length === 1) return names[0];
                        if (names.length > 1) {
                          const first = names[0];
                          return `${first}, ..`;
                        }
                        return $t("CHEGIRMA");
                      })()
                      : $t("CHEGIRMA")
                }}
              </v-btn>
            </template>

            <v-card
                :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                    v-model="searchDiscount"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredDiscount"
                      :key="item.id"
                      :label="item.isPercent ? `${item.promotion}%` : `${item.promotion} so'm`"
                      :value="item.id"
                      v-model="selectedDiscount"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="discountMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="paymentPercentWrapper"
              v-model="this.paymentPercentMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedPaymentPercent.length
                      ? (() => {
                        const names = paymentPercent
                            .filter(f => selectedPaymentPercent.includes(f.id))
                            .map(f => f.isPercent ? `${f.promotion}%` : `${f.promotion} so'm`);
                        if (names.length === 1) return names[0];
                        if (names.length > 1) {
                          const first = names[0];
                          return `${first}, ..`;
                        }
                        return $t("TO'LOV FOIZI");
                      })()
                      : $t("TO'LOV FOIZI")
                }}
              </v-btn>
            </template>

            <v-card
                :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                    v-model="searchPaymentPercent"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredPaymentPercent"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      v-model="selectedPaymentPercent"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="paymentPercentMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>

          <v-menu
              ref="documentStatusWrapper"
              v-model="documentStatusMenu"
              :close-on-content-click="false"
              offset-y
              transition="scale-transition primary-menu">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="button-primary" v-bind="attrs" v-on="on">
                {{
                  selectedDocumentStatus.length
                      ? (() => {
                        const names = documentStatus
                            .filter(f => selectedDocumentStatus.includes(f.id))
                            .map(f => f.name);
                        if (names.length === 1) return names[0];
                        if (names.length > 1) {
                          const first = names[0];
                          return `${first}, ..`;
                        }
                        return $t("HUJJATLARI");
                      })()
                      : $t("HUJJATLARI")
                }}
              </v-btn>
            </template>

            <v-card
                :style="{
                maxWidth: '274px',
                maxHeight: '400px',
                backgroundColor: $vuetify.theme.dark ? '#1a1b23!important' : '#FFF!important',
              }"
            >
              <v-card-title>
                <v-text-field
                    v-model="searchDocumentStatus"
                    :label="$t('Qidiruv')"
                    clearable
                    hide-details
                    dense
                />
              </v-card-title>

              <v-divider></v-divider>

              <v-card-text>
                <div style="display: flex; flex-wrap: wrap;">
                  <v-checkbox
                      v-for="item in filteredDocumentStatus"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      v-model="selectedDocumentStatus"
                      hide-details
                      dense
                      class="mr-4 mb-2"
                      style="min-width: 120px;"
                      @change="applyFilters"
                  />
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="documentStatusMenu = false">{{ $t("Close") }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>


          <!-- <v-text-field
            v-model="modernInput"
            label="Universal qidiruv"
            outlined
            dense
            rounded
            clearable
            style="min-width: 220px;"
          /> -->
        </div>


      </v-container>
    </v-fade-transition>


    <v-container fluid>
      <!-- Stat Cards2 -->
      <v-row dense>
        <v-col cols="12" sm="6" md="6" lg="4" v-for="card in cards2" :key="card.title">
          <v-card class="pa-5 stat-card" outlined>
            <template v-if="loading">
              <v-skeleton-loader type="heading, text, image"></v-skeleton-loader>
            </template>

            <template v-else>
              <div class="d-flex align-center justify-space-between mb-2">
                <div>
                  <div class="stat-title text-caption font-weight-bold text-uppercase">
                    {{ card.title }}
                  </div>
                  <div class="stat-value mt-1">
                    {{ card.format ? formatMoney(stats[card.value]) : formatInt(stats[card.value]) }}
                  </div>
                </div>

              </div>

              <v-progress-linear
                  v-if="card.progress"
                  :value="cardProgress(card.progress)"
                  :color="card.progressColor"
                  height="8"
                  rounded
                  :background-color="$vuetify.theme.dark ? '#22232e' : '#f2f3f5'"
              />
            </template>
          </v-card>
        </v-col>
      </v-row>


      <!-- Stat Cards -->
      <v-row dense>
        <v-col cols="12" sm="6" md="6" lg="6" v-for="card in cards" :key="card.title">
          <v-card class="pa-5 stat-card" outlined>
            <template v-if="loading">
              <v-skeleton-loader type="heading, text, image"></v-skeleton-loader>
            </template>

            <template v-else>
              <div class="d-flex align-center justify-space-between mb-2">
                <div>
                  <div class="stat-title text-caption font-weight-bold text-uppercase">
                    {{ card.title }}
                  </div>
                  <div class="stat-value mt-1">
                    {{ card.format ? formatMoney(stats[card.value]) : formatInt(stats[card.value]) }}
                  </div>
                </div>

              </div>

              <v-progress-linear
                  v-if="card.progress"
                  :value="cardProgress(card.progress)"
                  :color="card.progressColor"
                  height="8"
                  rounded
                  :background-color="$vuetify.theme.dark ? '#22232e' : '#f2f3f5'"
              />
            </template>
          </v-card>
        </v-col>
      </v-row>

      <!-- Doughnut & Bar -->
      <v-row class="mt-6" dense>
        <v-col cols="12" md="6">
          <div class="chart-card">
            <div class="chart-header">
              <h3 class="chart-title">{{ $t("To'lov Diagrammasi") }}</h3>
            </div>

            <div class="chart-wrapper">
              <template v-if="loading">
                <v-skeleton-loader type="image" class="fill"></v-skeleton-loader>
              </template>
              <canvas v-else ref="paymentChart"></canvas>
            </div>
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <div class="chart-card">
            <div class="chart-header">
              <h3 class="chart-title">{{ $t("Jinslar bo'yicha taqsimot") }}</h3>
            </div>

            <div class="chart-wrapper">
              <v-skeleton-loader v-if="genderLoading" type="image" class="fill" />
              <canvas ref="genderChart" v-show="!genderLoading"></canvas>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- Timeseries (only last 2 years) -->
      <v-row class="mt-4" dense>
        <v-col cols="12">
          <div class="chart-card">
            <div class="chart-header-row">
              <div class="chart-header">
                <h3 class="chart-title">{{ $t("To'lovlar tarixi") }}</h3>
              </div>

              <div class="chart-controls">
                <div class="chart-toggle-group">
                  <button
                    class="chart-toggle-btn"
                    :class="{ 'chart-toggle-btn--active': ts.mode === 'series' }"
                    :disabled="ts.loading || !ts.labels.length"
                    @click="ts.mode = 'series'; ts.page = 0"
                  >{{ $t("Kunlik") }}</button>
                  <button
                    class="chart-toggle-btn"
                    :class="{ 'chart-toggle-btn--active': ts.mode === 'cumulative' }"
                    :disabled="ts.loading || !ts.labels.length"
                    @click="ts.mode = 'cumulative'; ts.page = 0"
                  >{{ $t("Yig'indi") }}</button>
                </div>

                <div class="chart-toggle-group">
                  <button
                    class="chart-toggle-btn"
                    :class="{ 'chart-toggle-btn--active': ts.chartType === 'bar' }"
                    @click="ts.chartType = 'bar'; ts.page = 0"
                  ><v-icon size="13" class="mr-1">mdi-chart-bar</v-icon>{{ $t("Ustun") }}</button>
                  <button
                    class="chart-toggle-btn"
                    :class="{ 'chart-toggle-btn--active': ts.chartType === 'line' }"
                    @click="ts.chartType = 'line'; ts.page = 0"
                  ><v-icon size="13" class="mr-1">mdi-chart-line-variant</v-icon>{{ $t("Chiziq") }}</button>
                </div>

                <div class="chart-toggle-group">
                  <button
                    class="chart-toggle-btn"
                    :class="{ 'chart-toggle-btn--active': ts.bucket === 'day' }"
                    :disabled="ts.loading"
                    @click="ts.bucket = 'day'; reloadTimeseries()"
                  >{{ $t("Kun") }}</button>
                  <button
                    class="chart-toggle-btn"
                    :class="{ 'chart-toggle-btn--active': ts.bucket === 'week' }"
                    :disabled="ts.loading"
                    @click="ts.bucket = 'week'; reloadTimeseries()"
                  >{{ $t("Hafta") }}</button>
                  <button
                    class="chart-toggle-btn"
                    :class="{ 'chart-toggle-btn--active': ts.bucket === 'month' }"
                    :disabled="ts.loading"
                    @click="ts.bucket = 'month'; reloadTimeseries()"
                  >{{ $t("Oy") }}</button>
                </div>

                <v-select
                    v-if="isRecentYear"
                    dense
                    hide-details
                    outlined
                    class="chart-range-select"
                    :items="ts.rangeOptions"
                    v-model="ts.range"
                    :disabled="ts.loading"
                    @change="reloadTimeseries"
                    :menu-props="{ offsetY: true, bottom: true }"
                ></v-select>

              </div>
            </div>

            <!-- Hand-built chart — no Chart.js dependency -->
            <div v-if="ts.loading" class="ts-chart-area">
              <v-skeleton-loader type="image" class="fill"></v-skeleton-loader>
            </div>

            <!-- ── BAR chart ── -->
            <div v-else-if="ts.chartType === 'bar'" class="ts-chart-area">
              <div class="ts-y-axis">
                <span v-for="t in tsYTicks" :key="t.label" class="ts-y-tick" :style="{ bottom: t.pct + '%' }">{{ t.label }}</span>
              </div>
              <div class="ts-plot" @mouseleave="ts.hover = -1">
                <div v-for="t in tsYTicks" :key="'g'+t.label" class="ts-grid-line" :style="{ bottom: t.pct + '%' }"></div>
                <div
                  v-for="(bar, i) in tsPagedData"
                  :key="i"
                  class="ts-bar-col"
                  :style="{ width: (100 / tsPagedData.length) + '%' }"
                  @mouseenter="ts.hover = i"
                  @mouseleave="ts.hover = -1"
                >
                  <div class="ts-bar" :class="{ 'ts-bar--hover': ts.hover === i }" :style="{ height: bar.pct + '%' }"></div>
                  <span class="ts-x-label">{{ bar.label }}</span>
                  <div v-if="ts.hover === i" class="ts-tooltip">
                    <div class="ts-tooltip-title">{{ bar.tooltipTitle }}</div>
                    <div class="ts-tooltip-value">{{ bar.formatted }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ── LINE chart ── -->
            <div v-else class="ts-chart-area">
              <div class="ts-y-axis">
                <span v-for="t in tsYTicks" :key="'ly'+t.label" class="ts-y-tick" :style="{ bottom: t.pct + '%' }">{{ t.label }}</span>
              </div>
              <div class="ts-plot ts-plot--line" @mouseleave="ts.hover = -1">
                <div v-for="t in tsYTicks" :key="'lg'+t.label" class="ts-grid-line" :style="{ bottom: t.pct + '%' }"></div>

                <!-- SVG line + area fill -->
                <svg class="ts-line-svg" viewBox="0 0 1000 1000" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="tsAreaGrad" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" :stop-color="$vuetify.theme.dark ? '#2dd4bf' : '#14b8a6'" :stop-opacity="$vuetify.theme.dark ? 0.35 : 0.25"/>
                      <stop offset="100%" :stop-color="$vuetify.theme.dark ? '#2dd4bf' : '#14b8a6'" :stop-opacity="$vuetify.theme.dark ? 0.03 : 0.02"/>
                    </linearGradient>
                  </defs>
                  <polygon :points="tsAreaPoints" fill="url(#tsAreaGrad)"/>
                  <polyline :points="tsLinePoints" fill="none"
                    :stroke="$vuetify.theme.dark ? '#2dd4bf' : '#14b8a6'"
                    stroke-width="2.5" vector-effect="non-scaling-stroke"
                    stroke-linejoin="round" stroke-linecap="round"/>
                </svg>

                <!-- Dots layer — absolute, same box as SVG so coordinates match exactly -->
                <div class="ts-dot-layer">
                  <div
                    v-for="(bar, i) in tsPagedData"
                    :key="'d'+i"
                    class="ts-dot"
                    :class="{ 'ts-dot--hover': ts.hover === i }"
                    :style="{ left: ((i + 0.5) / tsPagedData.length * 100) + '%', bottom: bar.pct + '%' }"
                  ></div>
                </div>

                <!-- Invisible hover columns (tooltips only, no x-labels) -->
                <div
                  v-for="(bar, i) in tsPagedData"
                  :key="'lc'+i"
                  class="ts-line-col"
                  :style="{ width: (100 / tsPagedData.length) + '%' }"
                  @mouseenter="ts.hover = i"
                  @mouseleave="ts.hover = -1"
                >
                  <div v-if="ts.hover === i" class="ts-tooltip" :style="{ bottom: 'calc(' + bar.pct + '% + 24px)' }">
                    <div class="ts-tooltip-title">{{ bar.tooltipTitle }}</div>
                    <div class="ts-tooltip-value">{{ bar.formatted }}</div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!ts.loading && ts.chartType !== 'line' && ts.labels.length > tsPageSize" class="ts-pager">
              <button class="ts-pager-btn" :disabled="ts.page >= tsMaxPage" @click="ts.page++">
                <v-icon size="16">mdi-chevron-left</v-icon>
              </button>
              <span class="ts-pager-label">{{ tsPageLabel }}</span>
              <button class="ts-pager-btn" :disabled="ts.page <= 0" @click="ts.page--">
                <v-icon size="16">mdi-chevron-right</v-icon>
              </button>
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- ═══ Regional Map + Bar Chart ═══ -->
      <v-row class="mt-6" dense>
        <v-col cols="12" md="5">
          <div class="chart-card" style="height: 100%;">
            <div class="chart-header">
              <h3 class="chart-title">{{ $t("Regional information") }}</h3>
            </div>
            <div class="region-map-wrapper">
              <div v-if="regionLoading" class="region-map-loading">
                <v-progress-circular indeterminate color="blue" size="40"></v-progress-circular>
              </div>
              <div id="map" class="map_uzb"></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="7">
          <div class="chart-card" style="height: 100%;">
            <div class="chart-header">
              <h3 class="chart-title">{{ $t("Regionlar reytingi") }}</h3>
            </div>
            <div class="region-bar-chart-wrapper">
              <canvas ref="regionBarChart"></canvas>
            </div>
          </div>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
// Works with Chart.js v2 and v3/v4
import * as ChartModule from "chart.js";
import {ref, onMounted, getCurrentInstance, computed} from "vue";
import {mapGetters, mapActions} from "vuex";

const Chart = ChartModule.default || ChartModule.Chart || ChartModule;
if (ChartModule.registerables && Chart.register) {
  Chart.register(...ChartModule.registerables);
}

// Fix: CSS zoom + transform:scale on .ui-scale breaks Chart.js hover detection.
// Chart.js reads offsetX/offsetY which are NOT correctly adjusted for CSS zoom.
// Solution: intercept pointer/mouse events in the CAPTURE phase (before Chart.js
// listeners fire) and override offsetX/offsetY with values calculated from
// clientX/getBoundingClientRect which self-correct for any zoom/transform.
function _fixOffsetForZoom(e) {
  const canvas = e.target;
  if (!canvas || canvas.tagName !== 'CANVAS') return;
  const rect = canvas.getBoundingClientRect();
  const cssW = parseFloat(canvas.style.width) || canvas.clientWidth;
  const cssH = parseFloat(canvas.style.height) || canvas.clientHeight;
  if (!rect.width || !rect.height || !cssW || !cssH) return;
  // Skip if no zoom/transform discrepancy
  if (Math.abs(rect.width - cssW) < 2) return;
  const correctedX = (e.clientX - rect.left) / rect.width * cssW;
  const correctedY = (e.clientY - rect.top) / rect.height * cssH;
  Object.defineProperty(e, 'offsetX', { value: correctedX, configurable: true });
  Object.defineProperty(e, 'offsetY', { value: correctedY, configurable: true });
}

import axios from "axios";

const CHART_MAJOR = parseInt((Chart && Chart.version ? Chart.version.split(".")[0] : "2"), 10);
const isV3 = CHART_MAJOR >= 3;

export default {
  name: "Dashboard",

  setup() {
    const { proxy } = getCurrentInstance();
    const translatedAll = computed(() => proxy.$t('Barchasi'));

    const roleMenu = ref(false);
    const menuButton = ref(false);

    const isFiltering = ref(false);
    const menu = ref(false);
    const educationFacultyMenu = ref(false);
    const educationTypeMenu = ref(false);
    const educationLanguageMenu = ref(false);
    const groupMenu = ref(false);
    const regionMenu = ref(false);
    const districtMenu = ref(false);
    const genderMenu = ref(false);
    const discountMenu = ref(false);
    const paymentPercentMenu = ref(false);
    const documentStatusMenu = ref(false);
    const studyYearMenu = ref(false);
    const filters = ref({});
    const showFilters = ref(false);

    const group = ref([{ id: 0, name: translatedAll.value }]);
    const selectedGroup = ref([]);
    const searchGroup = ref('');
    const codesLoading = ref(false);
    const codesError = ref(null);

    const fetchGroupCodes = async () => {
      if (!await this.hasRole("GURUHLAR", "READ")) {
        return;
      }

      codesLoading.value = true;
      codesError.value = null;
      try {
        const {data} = await axios.get('api/groups/get/codes');
        const unique = Array.from(new Set((data || []).map(String)))
            .sort((a, b) => a.localeCompare(b, 'en'));
        group.value = [{id: 0, name: translatedAll.value}].concat(
            unique.map((code, i) => ({id: i + 1, name: code}))
        );
        const valid = new Set(group.value.map(g => g.id));
        selectedGroup.value = selectedGroup.value.filter(name => valid.has(name));
      } catch (e) {
        codesError.value = e?.response?.data?.message || e.message;
      } finally {
        codesLoading.value = false;
      }
    };

    onMounted(fetchGroupCodes);

    return {
      roleMenu,
      menu,
      educationFacultyMenu,
      educationTypeMenu,
      educationLanguageMenu,
      groupMenu,
      regionMenu,
      districtMenu,
      genderMenu,
      discountMenu,
      paymentPercentMenu,
      documentStatusMenu,
      studyYearMenu,
      isFiltering,
      filters,
      menuButton,
      showFilters,
      group,
      selectedGroup,
      searchGroup,
      codesLoading,
      codesError,
    };
  },

  data: (vm) => ({
    // global UI scale (90%)
    uiScale: 0.9,

    // Study year
    studyYearOptions: ['2026-2027', '2025-2026', '2024-2025', '2023-2024', '2022-2023'],
    selectedStudyYear: localStorage.getItem('last_selection') || '2026-2027',

    loading: false,
    lastUpdated: "",
    stats: {
      groupCount: 0,
      studentCount: 0,
      totalAmount: 0,
      payableAmount: 0,
      paidAmount: 0,
    },
    charts: {
      paymentChart: null,
      groupStudentChart: null,
      paymentsTrendChart: null,
      genderChart: null,
      regionBarChart: null,
    },
    regionBarData: [],
    cards: [
      {title: vm.$t("Guruhlar soni"), value: "groupCount", icon: "mdi-account-group", iconColor: "indigo"},
      {title: vm.$t("Talabalar soni"), value: "studentCount", icon: "mdi-school", iconColor: "deep-purple"},
    ],
    cards2: [
      {
        title: vm.$t("To'langan summa"),
        value: "paidAmount",
        format: true,
        icon: "mdi-cash-check",
        iconColor: "#ffd451",
        progress: "paid",
        progressColor: "green darken-1"
      },
      {
        title: vm.$t("To'lanishi kerak"),
        value: "payableAmount",
        format: true,
        icon: "mdi-cash-remove",
        iconColor: "red darken-1",
        progress: "remaining",
        progressColor: "red darken-1"
      },
      {
        title: vm.$t("Umumiy summa"),
        value: "totalAmount",
        format: true,
        icon: "mdi-cash-multiple",
        iconColor: "blue darken-1"
      },
    ],
    ts: {
      loading: false,
      bucket: "day",
      range: "last_6m",
      mode: "series",
      chartType: "bar",  // 'bar' or 'line'
      page: 0,          // 0 = latest (rightmost) page
      pageSize: 18,
      hover: -1,        // hovered bar index
      rangeOptions: [
        {text: vm.$t("Oxirgi 90 kun"), value: "last_90d"},
        {text: vm.$t("Yil boshidan (YTD)"), value: "ytd"},
        {text: vm.$t("Oxirgi 6 oy"), value: "last_6m"},
        {text: vm.$t("Oxirgi 12 oy"), value: "last_12m"},
      ],
      labels: [],
      dates: [],
      series: [],
      cumulative: [],
    },

    tab: Number(vm.$route.query.tab) || 0,
    isLoading: false,
    search: '',
    selected: [],
    dialog: false,
    buttonWidth: 0,

    options: [
      { id: 0, name: vm.$t("Barchasi") },
      { id: 1, name: '1-' + vm.$t("bosqich") },
      { id: 2, name: '2-' + vm.$t("bosqich") },
      { id: 3, name: '3-' + vm.$t("bosqich") },
      { id: 4, name: '4-' + vm.$t("bosqich") },
      { id: 5, name: '5-' + vm.$t("bosqich") },
    ],

    searchEducationFaculty: '',
    selectedEducationFaculty: [],
    dialogEducationFaculty: false,

    educationFaculty: [
      {id: 1, name: 'Logistika'},
      {id: 2, name: 'Boshlang`ich ta`lim'},
      {id: 3, name: 'Moliya va moliyaviy texnologiyalar'},
      {id: 4, name: 'Tarix'},
    ],

    searchEducationType: '',
    selectedEducationType: [],
    dialogEducationType: false,

    educationType: [
      { id: 1, name: vm.$t("Kunduzgi ta'lim") },
      { id: 2, name: vm.$t("Kechki ta'lim") },
      { id: 3, name: vm.$t("Sirtqi ta'lim") },
      { id: 4, name: vm.$t("Kunduzgi 3-smena") },
    ],

    searchEducationLanguage: '',
    selectedEducationLanguage: [],
    dialogEducationLanguage: false,

    educationLanguage: [
      { id: 1, name: vm.$t("O'zbek") },
      { id: 2, name: vm.$t("Rus") },
      { id: 3, name: vm.$t("Ingliz") }
    ],

    searchGroup: '',
    selectedGroup: [
      { id: 0, name: vm.$t("Barchasi") },
    ],
    dialogGroup: false,

    group: [
      { id: 1, name: vm.$t("Barchasi") },
      {id: 2, name: "Yangilar"},
      {id: 3, name: "5/23-MMT_S"},
      {id: 4, name: "129-MMT_S"},
      {id: 5, name: "138-MMT_S"},
      {id: 5, name: "139-MMT_S"},
    ],

    searchRegion: '',
    selectedRegion: [],
    dialogRegion: false,

    region: [
      { id: 1, name: vm.$t("Barchasi") },
      {id: 2, name: "Toshkent viloyati"},
      {id: 3, name: "Qashqadaryo viloyati"},
      {id: 4, name: "Xorazm viloyati"},
      {id: 5, name: "Buhoro viloyati"},
      {id: 5, name: "Surxondaryo viloyati"},
    ],

    searchDistrict: '',
    selectedDistrict: [],
    dialogDistrict: false,

    district: [
      {id: 1, name: "Ohangaron"},
      {id: 2, name: "Xonqa"},
      {id: 3, name: "Yangibozor"},
      {id: 4, name: "Olmaliq"},
    ],

    searchGender: '',
    selectedGender: [],
    dialogGender: false,

    gender: [
      { id: 1, name: vm.$t("Erkak") },
      { id: 2, name: vm.$t("Ayol") },
    ],

    searchDiscount: '',
    selectedDiscount: [],
    dialogDiscount: false,

    discount: [
      {
        "id": 2,
        "promotion": 2000,
        "isPercent": false
      },
      {
        "id": 3,
        "promotion": 70,
        "isPercent": true
      }
    ],

    searchPaymentPercent: '',
    selectedPaymentPercent: [],
    dialogPaymentPercent: false,

    paymentPercent: [
      {id: 0, name: "0%"},
      {id: 1, name: "10%"},
      {id: 2, name: "25%"},
      {id: 3, name: "50%"},
      {id: 4, name: "75%"},
      {id: 5, name: "100%"},
    ],

    searchDocumentStatus: '',          // qidirish uchun qiymat
    selectedDocumentStatus: [],        // tanlangan filterlar
    dialogDocumentStatus: false,       // dialog uchun (agar kerak bo'lsa)

    documentStatus: [
      { id: 0, name: vm.$t("Barchasi") },
      {id: 1, name: vm.$t("Qisman")},
      {id: 2, name: vm.$t("To'liq")},
    ],

    searchRole: '',          // qidirish uchun qiymat
    selectedRole: [],        // tanlangan filterlar
    dialogRole: false,       // dialog uchun (agar kerak bo'lsa)

    role: [
      {id: 0, name: vm.$t("Imtihon")},
      {id: 1, name: vm.$t("Magistratura")},
    ],

    genderLoading: false,
    genderError: null,
    genderStats: { male: 0, female: 0 },

    // ── Regional map ──
    regionLoading: false,
    mapdata: {
      main_settings: {
        width: "responsive",
        background_color: "#1a1b23",
        background_transparent: "yes",
        border_color: "#1a1b23",
        state_description: "State description",
        state_color: "#3a4260",
        state_hover_color: "#4a6fa5",
        state_url: "",
        border_size: 1.5,
        all_states_inactive: "no",
        all_states_zoomable: "no",
        location_description: "Location description",
        location_url: "",
        location_color: "#FF0067",
        location_opacity: 0.8,
        location_hover_opacity: 1,
        location_size: 25,
        location_type: "square",
        location_image_source: "frog.png",
        location_border_color: "#FFFFFF",
        location_border: 2,
        location_hover_border: 2.5,
        all_locations_inactive: "no",
        all_locations_hidden: "no",
        label_color: "#9ca3af",
        label_hover_color: "#ffffff",
        label_size: 16,
        label_font: "-apple-system, BlinkMacSystemFont, Arial",
        hide_labels: "no",
        hide_eastern_labels: "no",
        zoom: "no",
        manual_zoom: "no",
        back_image: "no",
        initial_back: "no",
        initial_zoom: "-1",
        initial_zoom_solo: "no",
        region_opacity: 1,
        region_hover_opacity: 0.6,
        zoom_out_incrementally: "no",
        zoom_percentage: 0.99,
        zoom_time: 0.5,
        popup_color: "#1e2030",
        popup_opacity: 0.97,
        popup_shadow: 4,
        popup_corners: 10,
        popup_font: "13px/1.5 -apple-system, BlinkMacSystemFont, Arial, sans-serif",
        popup_nocss: "no",
        div: "map",
        auto_load: "yes",
        url_new_tab: "no",
        images_directory: "default",
        fade_time: 0.1,
        link_text: "View Website",
        popups: "detect",
        state_image_url: "",
        state_image_position: "",
        location_image_url: "",
      },
      state_specific: {
        UZB356: { name: "Karakalpakstan", description: 0 },
        UZB355: { name: "Khorezm", description: 0 },
        UZB370: { name: "Jizzakh", description: 0 },
        UZB4828: { name: "Tashkent", description: 0 },
        UZB362: { name: "Surkhandarya", description: 0 },
        UZB371: { name: "Sirdaryo", description: 0 },
        UZB364: { name: "Ferghana", description: 0 },
        UZB365: { name: "Namangan", description: 0 },
        UZB361: { name: "Kashkadarya", description: 0 },
        UZB363: { name: "Andijon", description: 0 },
        UZB354: { name: "Bukhoro", description: 0 },
        UZB358: { name: "Samarkand", description: 0 },
        UZB372: { name: "Tashkent", description: 0 },
        UZB357: { name: "Navoi", description: 0 },
      },
      locations: {},
      labels: {},
      regions: {},
    },
    regionCodes: [
      { code: "UZB356", name: "Karakalpakstan" },
      { code: "UZB355", name: "Khorezm" },
      { code: "UZB370", name: "Jizzakh" },
      { code: "UZB4828", name: "Tashkent" },
      { code: "UZB362", name: "Surkhandarya" },
      { code: "UZB371", name: "Sirdaryo" },
      { code: "UZB364", name: "Ferghana" },
      { code: "UZB365", name: "Namangan" },
      { code: "UZB361", name: "Kashkadarya" },
      { code: "UZB363", name: "Andijon" },
      { code: "UZB354", name: "Bukhoro" },
      { code: "UZB358", name: "Samarkand" },
      { code: "UZB372", name: "Tashkent" },
      { code: "UZB357", name: "Navoi" },
    ],
  }),

  watch: {
    '$vuetify.theme.dark'() {
      // Re-render map + bar chart with correct theme colors
      this.loadRegionalData();
    },

    'stats.paidAmount'()       { this.refreshPaymentChart(); },
    'stats.payableAmount'()    { this.refreshPaymentChart(); },

    menu(val) {
      if (val) {
        this.$nextTick(() => {
          const button = this.$refs.menuButton?.$el || this.$refs.menuButton;
          this.buttonWidth = button ? button.offsetWidth : 0;
        });
      }
    },
    // Year/kurs
    selected(val) {
      if (val.id === 0) {
        this.selected = this.options.map(o => o.name)
      }
    },

    // Faculty
    selectedEducationFaculty(val) {
      if (val.id === 0) {
        this.selectedEducationFaculty = this.educationFaculty.map(o => o.name)
      }
    },

    // Education Type
    selectedEducationType(val) {
      if (val.id === 0) {
        this.selectedEducationType = this.educationType.map(o => o.name)
      }
    },

    // Education Language
    selectedEducationLanguage(val) {
      if (val.id === 0) {
        this.selectedEducationLanguage = this.educationLanguage.map(o => o.name)
      }
    },

    // Group codes
    // selectedGroup(val) {
    //   if (val.includes('Barchasi')) {
    //     this.selectedGroup = this.group.map(o => o.name)
    //   }
    // },


    // Region
    // selectedRegion(val) {
    //   // if "Barchasi" (id: 0) is selected, replace the selection with all real region ids
    //   if (val.includes(0)) {
    //     // all region ids except 0
    //     const allIds = this.region.filter(r => r.id !== 0).map(r => r.id);
    //     // avoid infinite loops: only set if it actually changed
    //     if (val.length !== allIds.length) {
    //       this.selectedRegion = allIds;
    //       return; // exit early, next tick will re-trigger applyFilters
    //     }
    //   }
    //   this.applyFilters();
    // },


    // District
    // selectedDistrict(val) {
    //   if (val.includes('Barchasi')) {
    //     this.selectedDistrict = this.district.map(o => o.name)
    //   }
    // },

    // Gender
    selectedGender(val) {
      if (val.id === 0) {
        this.selectedGender = this.gender.map(o => o.name)
      }
    },

    // Discount
    selectedDiscount(val) {
      if (val.id === 0) {
        this.selectedDiscount = this.discount.map(o => o.name)
      }
    },

    // Payment Percent
    selectedPaymentPercent(val) {
      if (val.id === 0) {
        this.selectedPaymentPercent = this.paymentPercent.map(o => o.name)
      }
    },
  },

  async created() {
    if (!await this.hasRole("DASHBOARD", "READ")) {
      await this.$router.push("/panels");
      return;
    }

    await this.loadFaculties();
    await this.fetchGroupCodes(); // ← NEW: call it here
    await this.fetchRegions(); // ← NEW
    await this.fetchDistricts();
    this.normalizeBosqichOptions(); // <— add this
    await this.fetchPromotions();
  },

  computed: {
    isRecentYear() {
      return this.studyYearOptions.indexOf(this.selectedStudyYear) < 2;
    },

    ...mapGetters("admin-contracts2025", ["GET_COUNT"]),
    ...mapGetters("auth", ["GET_USER"]),
    user: (vm) => vm.GET_USER,

    isSupperAdmin: (vm) => vm.user.role == "ADMIN_SUPER",
    filteredOptions() {
      const s = this.search.toLowerCase();
      return this.options.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredEducationFaculty() {
      const s = this.searchEducationFaculty.toLowerCase();
      return this.educationFaculty.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredEducationType() {
      const s = this.searchEducationType.toLowerCase();
      return this.educationType.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredEducationLanguage() {
      const s = this.searchEducationLanguage.toLowerCase();
      return this.educationLanguage.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredRegion() {
      const s = this.searchRegion.toLowerCase();
      return (this.region || []).filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredDistrict() {
      const s = this.searchDistrict.toLowerCase();
      return (this.district || []).filter(o => o.name.toLowerCase().includes(s));
    },

    filteredGender() {
      const s = this.searchGender.toLowerCase();
      return this.gender.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredDiscount() {
      const s = this.searchDiscount.toLowerCase();
      return this.discount.filter((o) => {
        // Compose a label string for searching
        const label = o.isPercent
            ? `${o.promotion}%`
            : `${o.promotion} so'm`;
        return label.toLowerCase().includes(s);
      });
    },

    filteredPaymentPercent() {
      const s = this.searchPaymentPercent.toLowerCase();
      return this.paymentPercent.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredDocumentStatus() {
      const s = this.searchDocumentStatus.toLowerCase();
      return this.documentStatus.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredRole() {
      const s = this.searchRole.toLowerCase();
      return this.role.filter((o) => o.name.toLowerCase().includes(s));
    },

    filteredGroup() {
      const s = (this.searchGroup || '').toLowerCase();
      return (this.group || []).filter(o => (o.name || '').toLowerCase().includes(s));
    },

    paymentTotal() {
      const paid = Number(this.stats.paidAmount || 0);
      const rem = Number(this.stats.payableAmount || 0);
      return paid + rem;
    },
    /** Line chart: all data on one page; bar chart: 18 per page */
    tsPageSize() {
      return this.ts.chartType === 'line' ? this.ts.labels.length || 1 : 30;
    },
    tsMaxPage() {
      return Math.max(0, Math.ceil(this.ts.labels.length / this.tsPageSize) - 1);
    },
    tsPageLabel() {
      const total = this.ts.labels.length;
      if (!total) return '';
      const end = total - this.ts.page * this.tsPageSize;
      const start = Math.max(1, end - this.tsPageSize + 1);
      return `${start}–${end} / ${total}`;
    },
    tsPagedData() {
      const allValues = this.ts.mode === 'cumulative' ? this.ts.cumulative : this.ts.series;
      const allLabels = this.ts.labels;
      const allDates = this.ts.dates;
      const total = allLabels.length;
      const size = this.tsPageSize;
      const end = total - this.ts.page * size;
      const start = Math.max(0, end - size);
      const labels = allLabels.slice(start, end);
      const dates = allDates.slice(start, end);
      const values = allValues.slice(start, end);
      const max = Math.max(...values, 1);
      const fmt = new Intl.NumberFormat('uz-UZ');
      const monthNames = ['Yanvar','Fevral','Mart','Aprel','May','Iyun','Iyul','Avgust','Sentabr','Oktabr','Noyabr','Dekabr'];
      return labels.map((l, i) => {
        const iso = dates[i] || '';
        const m = parseInt(iso.substring(5, 7), 10);
        const d = parseInt(iso.substring(8, 10), 10);
        const tooltipTitle = monthNames[m - 1] + ' ' + d;
        return {
          label: l,
          tooltipTitle: tooltipTitle,
          value: values[i] || 0,
          pct: ((values[i] || 0) / max) * 100,
          formatted: fmt.format(values[i] || 0) + " so'm",
        };
      });
    },
    tsYTicks() {
      const allValues = this.ts.mode === 'cumulative' ? this.ts.cumulative : this.ts.series;
      const total = allValues.length;
      const size = this.tsPageSize;
      const end = total - this.ts.page * size;
      const start = Math.max(0, end - size);
      const values = allValues.slice(start, end);
      const max = Math.max(...values, 1);
      // Generate ~5 nice ticks
      const raw = max / 5;
      const mag = Math.pow(10, Math.floor(Math.log10(raw || 1)));
      const nice = Math.max(1, [1,2,2.5,5,10].find(n => n * mag >= raw) * mag);
      const ticks = [];
      for (let v = 0; v <= max; v += nice) {
        ticks.push({ label: this.fmtTickVal(v), pct: (v / max) * 100 });
      }
      return ticks;
    },
    /** SVG polyline points for line chart */
    tsLinePoints() {
      const data = this.tsPagedData;
      const n = data.length;
      if (!n) return '';
      return data.map((d, i) => {
        const x = (i + 0.5) / n * 1000;
        const y = 1000 - d.pct * 10;
        return `${x},${y}`;
      }).join(' ');
    },
    /** SVG polygon points for area fill under line */
    tsAreaPoints() {
      const data = this.tsPagedData;
      const n = data.length;
      if (!n) return '';
      const pts = data.map((d, i) => {
        const x = (i + 0.5) / n * 1000;
        const y = 1000 - d.pct * 10;
        return `${x},${y}`;
      });
      const firstX = (0.5 / n * 1000);
      const lastX = ((n - 0.5) / n * 1000);
      return pts.join(' ') + ` ${lastX},1000 ${firstX},1000`;
    },
    // inline style ensures correct width after scaling
    scaleStyle() {
      const s = this.uiScale || 1;
      return {
        zoom: s,                        // Chrome/Edge
        transform: `scale(${s})`,       // Fallback (Firefox, Safari)
        transformOrigin: "top left",
        width: `calc(100% / ${s})`,     // keeps layout width at 100% post-scale
      };
    },

  },

  methods: {
    ...mapActions("admin-contracts2025", ["INIT_COUNT", "INIT_FILTERED_APPLICATIONS", "INIT_FACULTIES"]),

    async hasRole(panel, op) {
      try {
        const res = await axios.get(`/admin/panel-permissions/check`, {
          params: { appPanel: panel, op }
        });
        return res.data === true;
      } catch {
        return false;
      }
    },

    /** Get a safe 2D context from a canvas ref (handles wrappers / missing refs) */
    getCtx(refName) {
      const el = this.$refs[refName];
      if (!el) return null;
      const node = el instanceof HTMLCanvasElement ? el : el.$el || el;
      const canvas = node?.tagName === 'CANVAS' ? node : node?.querySelector?.('canvas');
      return canvas ? canvas.getContext('2d') : null;
    },

    async fetchGenderStats() {
      this.genderLoading = true;
      this.genderError = null;
      try {
        let resp;
        if (this.isFiltering) {
          resp = await axios.post('/admin/common/gender/filter',
            this.filters || {}
          );
        } else {
          resp = await axios.get('/admin/common/gender', {
            params: { studyYear: this.selectedStudyYear },
            headers: {
              Authorization: `Bearer ${this.GET_USER?.token || ''}`,
              'Accept-Language': 'uz',
            }
          });
        }

        // Example payload: [{"gender":"MALE","quantity":5},{"gender":"FEMALE","quantity":12}]
        const arr = Array.isArray(resp.data) ? resp.data : [];
        const male = arr.find(x => String(x.gender).toUpperCase() === 'MALE')?.quantity || 0;
        const female = arr.find(x => String(x.gender).toUpperCase() === 'FEMALE')?.quantity || 0;
        this.genderStats = { male: Number(male) || 0, female: Number(female) || 0 };

        this.$nextTick(this.updateGenderChart);
      } catch (e) {
        this.genderError = e?.response?.data?.message || e.message || 'Gender statistikasi yuklanmadi';
      } finally {
        this.genderLoading = false;
      }
    },

    // ── Regional map helpers ──
    async loadRegionalData() {
      this.regionLoading = true;
      try {
        // Remove old map scripts before re-injecting
        this.removeMapScript('countrymap_config');
        this.removeMapScript('countrymap');

        // Also remove the old map container inner HTML so SimpleMap re-renders
        const mapEl = document.getElementById('map');
        if (mapEl) mapEl.innerHTML = '';

        // Theme-aware map background (map regions stay dark-styled, background matches card)
        const isDark = this.$vuetify.theme.dark;
        this.mapdata.main_settings.background_color = isDark ? '#1a1b23' : '#ffffff';
        this.mapdata.main_settings.border_color = isDark ? '#1a1b23' : '#e2e8f0';
        this.mapdata.main_settings.label_color = isDark ? '#9ca3af' : '#64748b';
        this.mapdata.main_settings.label_hover_color = isDark ? '#ffffff' : '#0f172a';

        let resp;
        if (this.isFiltering) {
          resp = await axios.post('/admin/common/regional/filter', this.filters || {});
        } else {
          resp = await axios.get('/admin/common/regional', {
            params: { studyYear: this.selectedStudyYear },
            headers: {
              Authorization: `Bearer ${this.GET_USER?.token || ''}`,
              'Accept-Language': 'uz',
            }
          });
        }

        const regions = Array.isArray(resp.data) ? resp.data : [];

        // Calculate min/max for gradient coloring
        const quantities = regions.map(r => r.quantity || 0);
        const maxQ = Math.max(...quantities, 1);
        const minQ = Math.min(...quantities, 0);

        // Gradient: dark blue (#2a3a5c) → gold (#FFD700) based on quantity
        const regionColor = (qty) => {
          const t = maxQ > minQ ? (qty - minQ) / (maxQ - minQ) : 0;
          const r = Math.round(42 + t * (255 - 42));
          const g = Math.round(58 + t * (215 - 58));
          const b = Math.round(92 + t * (0 - 92));
          return '#' + [r, g, b].map(v => v.toString(16).padStart(2, '0')).join('');
        };

        // Map API response onto state_specific codes with gradient colors
        this.mapdata.state_specific = this.regionCodes
          .map((key) => {
            const obj = {};
            const region = regions.find((r) => r.code === key.code) || {};
            const qty = region.quantity || 0;
            obj[key.code] = {};
            obj[key.code].name = region.regionName || key.name;
            obj[key.code].description = qty;
            obj[key.code].color = regionColor(qty);
            return obj;
          })
          .reduce((a, b) => Object.assign(a, b), {});

        // Store sorted region data for horizontal bar chart
        this.regionBarData = this.regionCodes
          .map((key) => {
            const region = regions.find((r) => r.code === key.code) || {};
            return {
              name: region.regionName || key.name,
              quantity: region.quantity || 0,
            };
          })
          .sort((a, b) => b.quantity - a.quantity);
      } catch (e) {
        console.error('Regional data load error', e);
        // Keep default state_specific with zeroes so map still renders
      } finally {
        // Always inject the map scripts (even on API error — shows the map with 0s)
        this.addMapScript(
          'countrymap_config',
          null,
          `var simplemaps_countrymap_mapdata = ${JSON.stringify(this.mapdata)}`
        );
        this.addMapScript('countrymap', '/country-statistics/countrymap.js');
        this.regionLoading = false;

        // Update horizontal bar chart
        this.$nextTick(() => this.updateRegionBarChart());

        // Force dark tooltip styles when SimpleMap shows/hides it
        this.$nextTick(() => {
          setTimeout(() => {
            this.setupTooltipObserver();
          }, 1500);
        });
      }
    },

    setupTooltipObserver() {
      if (this._tooltipObserver) this._tooltipObserver.disconnect();
      const tt = document.getElementById('tt_sm_map');
      if (!tt) return;
      const forceStyles = () => {
        tt.style.setProperty('background', '#1e2030', 'important');
        tt.style.setProperty('border', '1px solid #2a2c3a', 'important');
        tt.style.setProperty('z-index', '9999', 'important');
        tt.style.setProperty('box-shadow', '0 8px 24px rgba(0,0,0,0.5)', 'important');
        const inner = tt.querySelector('.tt_sm');
        if (inner) {
          inner.style.setProperty('background', '#1e2030', 'important');
          inner.style.setProperty('color', '#e4e5eb', 'important');
          inner.style.setProperty('box-shadow', 'none', 'important');
        }
      };
      forceStyles();
      this._tooltipObserver = new MutationObserver(forceStyles);
      this._tooltipObserver.observe(tt, { attributes: true, attributeFilter: ['style'], childList: true, subtree: true });
    },

    addMapScript(id, src, text) {
      if (document.getElementById(id) || (!src && !text)) return;
      const script = document.createElement('script');
      script.setAttribute('type', 'text/javascript');
      if (src) script.setAttribute('src', src);
      else script.textContent = text;
      script.setAttribute('id', id);
      document.head.appendChild(script);
    },

    removeMapScript(id) {
      const el = document.getElementById(id);
      if (el) el.remove();
    },

    updateRegionBarChart() {
      const ctx = this.getCtx('regionBarChart');
      if (!ctx) return;

      // Destroy old chart
      if (this.charts.regionBarChart) {
        this.charts.regionBarChart.destroy();
        this.charts.regionBarChart = null;
      }

      const isDark = this.$vuetify.theme.dark;
      const data = this.regionBarData;
      const labels = data.map(d => d.name);
      const values = data.map(d => d.quantity);
      // Gold gradient
      const canvas = this.$refs.regionBarChart;
      const chartCtx = canvas.getContext('2d');
      const grad = chartCtx.createLinearGradient(0, 0, canvas.width, 0);
      grad.addColorStop(0, '#DAA520');
      grad.addColorStop(1, '#FFD700');

      // Theme-aware colors
      const gridColor = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)';
      const xTickColor = isDark ? '#8b8d9e' : '#6b7280';
      const yTickColor = isDark ? '#e4e5eb' : '#1f2937';
      const tooltipBg = isDark ? '#1e2030' : '#ffffff';
      const tooltipTitleClr = isDark ? '#e4e5eb' : '#1f2937';
      const tooltipBodyClr = isDark ? '#e4e5eb' : '#374151';
      const tooltipBorder = isDark ? 'rgba(42,44,58,0.8)' : 'rgba(0,0,0,0.1)';
      const labelFill = '#1a1b23'; // dark text on gold bars works for both themes

      // Inline plugin to draw value labels at start of bars
      const barLabelPlugin = {
        id: 'regionBarLabels',
        afterDatasetsDraw(chart) {
          const { ctx: c, data: d } = chart;
          const meta = chart.getDatasetMeta(0);
          c.save();
          c.font = 'bold 12px -apple-system, BlinkMacSystemFont, sans-serif';
          c.textBaseline = 'middle';
          c.textAlign = 'left';
          c.fillStyle = labelFill;
          meta.data.forEach((bar, i) => {
            const val = d.datasets[0].data[i];
            if (val > 0) {
              const text = new Intl.NumberFormat('uz-UZ').format(val);
              c.fillText(text, bar.base + 8, bar.y);
            }
          });
          c.restore();
        }
      };

      const chartOpts = isV3
        ? {
            indexAxis: 'y',
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              tooltip: {
                backgroundColor: tooltipBg,
                titleColor: tooltipTitleClr,
                bodyColor: tooltipBodyClr,
                borderColor: tooltipBorder,
                borderWidth: 1,
                titleFont: { size: 13, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                bodyFont: { size: 14, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                padding: { top: 10, bottom: 10, left: 14, right: 14 },
                cornerRadius: 10,
                displayColors: false,
                callbacks: {
                  label: (c) => ` ${new Intl.NumberFormat('uz-UZ').format(c.parsed.x)} ta`
                }
              }
            },
            scales: {
              x: {
                beginAtZero: true,
                grid: { color: gridColor, drawBorder: false },
                ticks: {
                  color: xTickColor,
                  font: { size: 11, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                  padding: 4,
                },
                border: { display: false },
              },
              y: {
                grid: { display: false },
                ticks: {
                  color: yTickColor,
                  font: { size: 13, family: "-apple-system, BlinkMacSystemFont, sans-serif", weight: '600' },
                  padding: 10,
                },
                border: { display: false },
              },
            },
            layout: { padding: { top: 6, bottom: 6, left: 0, right: 16 } },
          }
        : {
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: false },
            scales: {
              xAxes: [{ gridLines: { color: gridColor, drawBorder: false }, ticks: { beginAtZero: true, fontColor: xTickColor, fontSize: 11 } }],
              yAxes: [{ gridLines: { display: false }, ticks: { fontColor: yTickColor, fontSize: 13 } }],
            },
          };

      this.charts.regionBarChart = new Chart(ctx, {
        type: isV3 ? 'bar' : 'horizontalBar',
        data: {
          labels,
          datasets: [{
            data: values,
            backgroundColor: grad,
            borderColor: '#DAA520',
            borderWidth: 0,
            borderRadius: isV3 ? 6 : 0,
            barThickness: 26,
            maxBarThickness: 30,
            minBarLength: 46,
          }],
        },
        options: chartOpts,
        plugins: isV3 ? [barLabelPlugin] : [],
      });
    },

    updateGenderChart() {
      const ctx = this.getCtx('genderChart');
      if (!ctx) return;

      // destroy old
      if (this.charts.genderChart) {
        this.charts.genderChart.destroy();
        this.charts.genderChart = null;
      }

      const labels = [this.$t('Erkak'), this.$t('Ayol')];
      const values = [this.genderStats.male, this.genderStats.female];

      // Create gradients
      const canvas = this.$refs.genderChart;
      const chartCtx = canvas.getContext('2d');
      const maleGrad = chartCtx.createLinearGradient(0, 0, 0, 300);
      maleGrad.addColorStop(0, '#3b82f6');
      maleGrad.addColorStop(1, '#1d4ed8');
      const femaleGrad = chartCtx.createLinearGradient(0, 0, 0, 300);
      femaleGrad.addColorStop(0, '#a78bfa');
      femaleGrad.addColorStop(1, '#7c3aed');

      const barOpts = isV3
          ? {
            responsive: true, maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              tooltip: {
                backgroundColor: '#1f2937',
                titleFont: { size: 12, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                bodyFont: { size: 13, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                padding: { top: 10, bottom: 10, left: 14, right: 14 },
                cornerRadius: 10,
                displayColors: true,
                boxPadding: 6,
                callbacks: { label: (c) => ` ${new Intl.NumberFormat('uz-UZ').format(c.parsed.y)} ta` }
              }
            },
            scales: {
              x: {
                grid: { display: false },
                ticks: { color: '#9ca3af', font: { size: 12, family: "-apple-system, BlinkMacSystemFont, sans-serif", weight: '500' } },
              },
              y: {
                beginAtZero: true,
                grid: { color: 'rgba(0,0,0,0.04)', drawBorder: false },
                ticks: { color: '#9ca3af', font: { size: 11, family: "-apple-system, BlinkMacSystemFont, sans-serif" }, padding: 8 },
                border: { display: false },
              },
            },
          }
          : {
            responsive: true, maintainAspectRatio: false,
            legend: { display: false },
            scales: {
              xAxes: [{ gridLines: { display: false }, ticks: { fontColor: '#9ca3af', fontSize: 12 } }],
              yAxes: [{ ticks: { beginAtZero: true, fontSize: 11, fontColor: '#9ca3af', padding: 8 }, gridLines: { color: 'rgba(0,0,0,0.04)', drawBorder: false } }],
            },
            tooltips: {
              backgroundColor: '#1f2937', cornerRadius: 10, xPadding: 14, yPadding: 10,
              callbacks: { label: (ti) => ` ${new Intl.NumberFormat('uz-UZ').format(ti.yLabel)} ta` }
            },
          };

      this.charts.genderChart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [{
            label: 'Soni',
            data: values,
            backgroundColor: [maleGrad, femaleGrad],
            hoverBackgroundColor: ['#2563eb', '#6d28d9'],
            maxBarThickness: 80,
            borderRadius: 8,
            borderSkipped: false,
          }]
        },
        options: barOpts
      });
    },

    refreshPaymentChart() {
      const paid = Number(this.stats?.paidAmount || 0);
      const rem  = Number(this.stats?.payableAmount || 0);

      const ctx = this.getCtx('paymentChart');
      if (!ctx) return;

      if (!this.charts.paymentChart) {
        const doughnutOpts = isV3
            ? {
              responsive: true,
              maintainAspectRatio: false,
              cutout: '72%',
              plugins: {
                legend: {
                  position: "bottom",
                  labels: {
                    color: "#6b7280",
                    font: { size: 12, family: "-apple-system, BlinkMacSystemFont, sans-serif", weight: '500' },
                    usePointStyle: true,
                    pointStyle: 'circle',
                    padding: 20,
                  },
                },
                tooltip: {
                  backgroundColor: '#1f2937',
                  titleFont: { size: 12, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                  bodyFont: { size: 13, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                  padding: { top: 10, bottom: 10, left: 14, right: 14 },
                  cornerRadius: 10,
                  displayColors: true,
                  boxPadding: 6,
                  callbacks: {
                    label: (c) => ' ' + new Intl.NumberFormat("uz-UZ").format(c.parsed) + " so'm",
                  },
                },
              },
            }
            : {
              responsive: true,
              maintainAspectRatio: false,
              cutoutPercentage: 72,
              animation: { animateScale: true, animateRotate: true },
              legend: { position: "bottom", labels: { fontSize: 12, fontColor: "#6b7280", usePointStyle: true, padding: 20 } },
              tooltips: {
                backgroundColor: '#1f2937',
                cornerRadius: 10,
                xPadding: 14, yPadding: 10,
                callbacks: {
                  label: (ti, data) => {
                    const val = data.datasets[ti.datasetIndex].data[ti.index] || 0;
                    return ' ' + new Intl.NumberFormat("uz-UZ").format(val) + " so'm";
                  },
                },
              },
            };

        this.charts.paymentChart = new Chart(ctx, {
          type: "doughnut",
          data: {
            labels: [this.$t("To'langan"), this.$t("To'lanishi kerak")],
            datasets: [{
              data: [paid, rem],
              backgroundColor: ["#43A047", "#e53935"],
              hoverBackgroundColor: ["#2E7D32", "#c62828"],
              borderWidth: 0,
              hoverOffset: 6,
              borderRadius: 4,
              spacing: 2,
            }],
          },
          options: doughnutOpts,
        });
        return;
      }

      // update existing
      const ds = this.charts.paymentChart.data.datasets[0];
      ds.data = [paid, rem];
      this.charts.paymentChart.update();
    },

    async fetchRegions() {
      this.regionsLoading = true;
      this.regionsError = null;
      try {
        const {data} = await axios.get('admin/region?page=0&size=120&name=null&sortField=&sortOrder=asc', {
          headers: {
            Authorization: `Bearer ${this.GET_USER?.token || ''}`,
            'Accept-Language': 'uz',
          }
        });

        const regionList = (data?.content || []).map(region => ({
          id: region.id,
          name: region.names?.uz || region.names?.en || region.names?.ru || '---'
        }));

        this.region = [{id: 0, name: this.$t('Barchasi')}, ...regionList];
        console.log(this.region)
      } catch (e) {
        this.regionsError = e?.response?.data?.message || e.message || 'Failed to load regions';
      } finally {
        this.regionsLoading = false;
      }
    },

    async fetchPromotions() {
      // this.promotionsLoading = true;
      // this.promotionsError = null;
      try {
        const {data} = await axios.get(
            "/admin/promotions"
        );
        this.discount = data;
      } catch (e) {
        //  this.promotionsError = e?.response?.data?.message || e.message || "Failed to load promotions";
      } finally {
        //  this.promotionsLoading = false;
      }
    },

    normalizeBosqichOptions() {
      // keep a single Barchasi at the top
      const rest = this.options.filter(o => o.id !== 0);
      this.options = [{id: 0, name: this.$t('Barchasi')}, ...rest];

      // keep selected numeric & valid
      const valid = new Set(this.options.map(o => o.id));
      this.selected = (this.selected || []).filter(id => typeof id === 'number' && valid.has(id));
    },

    onBosqichChange(item) {
      const ALL = 0;                                  // id of "Barchasi"
      const allIds = this.options.map(o => o.id);     // [0,1,2,3,4,5]

      // wait for v-model to finish
      this.$nextTick(() => {
        const allNowChecked = this.selected.includes(ALL);

        if (item.id === ALL) {
          // Clicked Barchasi -> select all or clear all
          this.selected = allNowChecked ? allIds.slice() : [];
          this.applyFilters();
          return;
        }

        // Clicked a regular item
        // remove Barchasi if present
        this.selected = this.selected.filter(v => v !== ALL);

        // if all individual items are selected, auto-check Barchasi
        const indiv = allIds.filter(id => id !== ALL);
        const selIndiv = this.selected.filter(id => id !== ALL);
        if (selIndiv.length === indiv.length) {
          this.selected = allIds.slice();
        }

        this.applyFilters();
      });
    },

    onRegionChange(item) {
      const ALL = 0;                                // id of "Barchasi"
      const allIds = this.region.map(r => r.id);    // includes 0

      this.$nextTick(() => {
        const isAllNowChecked = this.selectedRegion.includes(ALL);

        if (item.id === ALL) {
          // User clicked "Barchasi": select-all if it's now checked, else clear all
          this.selectedRegion = isAllNowChecked ? allIds.slice() : [];
          this.applyFilters();
          return;
        }

        // User toggled a regular region
        // remove "Barchasi" if present
        this.selectedRegion = this.selectedRegion.filter(v => v !== ALL);

        // If now every individual is selected, auto-add "Barchasi"
        const indiv = allIds.filter(id => id !== ALL);
        const selIndiv = this.selectedRegion.filter(id => id !== ALL);
        if (selIndiv.length === indiv.length) {
          this.selectedRegion = allIds.slice();     // adds ALL + all ids
        }

        this.applyFilters();
      });
    },

    onDistrictChange(item) {
      const ALL = 0;                                      // id of "Barchasi"
      const allIds = this.district.map(d => d.id);        // includes 0

      this.$nextTick(() => {
        const isAllNowChecked = this.selectedDistrict.includes(ALL);

        if (item.id === ALL) {
          // Clicked Barchasi
          this.selectedDistrict = isAllNowChecked ? allIds.slice() : [];
          this.applyFilters();
          return;
        }

        // Clicked a regular district
        this.selectedDistrict = this.selectedDistrict.filter(v => v !== ALL);

        const indiv = allIds.filter(id => id !== ALL);
        const selIndiv = this.selectedDistrict.filter(id => id !== ALL);
        if (selIndiv.length === indiv.length) {
          this.selectedDistrict = allIds.slice(); // auto add ALL + all ids
        }

        this.applyFilters();
      });
    },

    onGroupChange(item) {
      const ALL = this.$t('Barchasi');
      const allValues = this.group.map(g => g.name); // includes 'Barchasi'
      const hasAll = this.selectedGroup.includes(ALL);

      if (item.name === ALL) {
        this.selectedGroup = hasAll ? allValues.slice() : [];
      } else {
        if (hasAll) {
          this.selectedGroup = this.selectedGroup.filter(v => v !== ALL);
        }
        const indiv = allValues.filter(v => v !== ALL);
        const selectedIndiv = this.selectedGroup.filter(v => v !== ALL);
        if (selectedIndiv.length === indiv.length) {
          this.selectedGroup = allValues.slice();
        }
      }
      this.applyFilters();
    },

    async fetchDistricts() {
      this.districtsLoading = true;
      this.districtsError = null;
      try {
        const {data} = await axios.get('admin/city?page=0&size=200&name=null&sortField=&sortOrder=asc', {
          headers: {
            Authorization: `Bearer ${this.GET_USER?.token || ''}`,
            'Accept-Language': 'uz',
          }
        });

        const districtList = (data?.content || []).map(city => ({
          id: city.id,
          name: city.names?.uz || city.names?.en || city.names?.ru || '---'
        }));

        this.district = [{id: 0, name: this.$t('Barchasi')}, ...districtList];
      } catch (e) {
        this.districtsError = e?.response?.data?.message || e.message || 'Failed to load districts';
      } finally {
        this.districtsLoading = false;
      }
    },

    async fetchDistrictsByRegions(regionIds) {
      this.districtsLoading = true;
      this.districtsError = null;

      if (!regionIds || regionIds.length === 0) {
        this.district = [{id: 0, name: this.$t('Barchasi')}];
        this.districtsLoading = false;
        return;
      }

      try {
        const allRequests = regionIds.map(regionId => {
          return axios.get(`admin/city/all/${regionId}`, {
            headers: {
              Authorization: `Bearer ${this.GET_USER?.token || ''}`,
              'Accept-Language': 'uz',
            }
          }).then(res => res.data || []).catch(() => []);
        });

        const results = await Promise.all(allRequests);
        const merged = results.flat();

        // Deduplicate by ID
        const seen = new Set();
        const uniqueDistricts = merged
            .filter(city => city?.id && !seen.has(city.id) && seen.add(city.id))
            .map(city => ({
              id: city.id,
              name: city.name || '---',
            }));

        this.district = [{id: 0, name: this.$t('Barchasi')}, ...uniqueDistricts];
      } catch (e) {
        this.districtsError = e?.response?.data?.message || e.message || 'Failed to load districts';
      } finally {
        this.districtsLoading = false;
      }
    },

    async fetchDiscount() {

    },

    fetchCounts() {
      this.isFiltering = false;
      this.filters = {};

      this.INIT_COUNT();
    },

    async loadFaculties() {
      const faculties = await this.INIT_FACULTIES();
      console.log("Faculties loaded:", faculties);
      this.educationFaculty = faculties;
    },

    applyFilters() {
      console.log("selectedRole", this.selectedRole.length)
      // Helper: remove "Barchasi" ID (0) from an array
      const dropAll = arr => (arr || []).filter(id => id !== 0);

      // Mark filtering active if any filter has a value
      this.isFiltering =
          this.selectedEducationFaculty.length > 0 ||
          this.selected.length > 0 ||
          this.selectedEducationType.length > 0 ||
          this.selectedEducationLanguage.length > 0 ||
          this.selectedGroup.length > 0 ||
          this.selectedRegion.length > 0 ||
          this.selectedDistrict.length > 0 ||
          this.selectedGender.length > 0 ||
          this.selectedDiscount.length > 0 ||
          this.selectedPaymentPercent.length > 0 ||
          this.selectedDocumentStatus.length > 0 ||
          this.selectedRole.length > 0;

      // Prepare cleaned region and district IDs (no Barchasi=0)
      const regionIdsClean = dropAll(this.selectedRegion);
      const districtIdsClean = dropAll(this.selectedDistrict);
      const bosqichClean = (this.selected || []).filter(id => id !== 0);

      // Update districts list depending on region selection
      if (regionIdsClean.length > 0) {
        console.log("Fetching districts for selected regions:", regionIdsClean);
        this.fetchDistrictsByRegions(regionIdsClean);
      } else {
        this.district = [{id: 0, name: this.$t('Barchasi')}];
        this.fetchDistricts(); // Reset to all districts
      }

      // Build final filters object for backend
      const filters = {
        kurs: bosqichClean.map(String),
        selectedEducationFaculties: this.selectedEducationFaculty.map(String),
        selectedEducationTypes: this.selectedEducationType.map(String),
        selectedEducationLanguages: this.selectedEducationLanguage.map(String),
        selectedGroups: this.selectedGroup.map(String), // group still name-based
        selectedRegions: regionIdsClean.map(String),
        selectedDistricts: districtIdsClean.map(String),
        selectedGenders: this.selectedGender.map(o => o === 1 ? "MALE" : "FEMALE"),
        selectedDiscounts: this.selectedDiscount.map(String),
        selectedPaymentPercents: this.selectedPaymentPercent.map(String),
        selectedDocumentStatus: this.selectedDocumentStatus.map(String),
        selectedRole: this.selectedRole.map(String),
        studyYear: this.selectedStudyYear,
      };

      // Save for use by your API call
      this.filters = filters;
      this.loadData();

      this.reloadTimeseries();

      this.fetchGenderStats();
      this.loadRegionalData();
    },

    onStudyYearSelect(year) {
      this.selectedStudyYear = year;
      this.onStudyYearChange(year);
    },

    onStudyYearChange(val) {
      localStorage.setItem('last_selection', val);
      this.loadData();
      this.reloadTimeseries();
      this.fetchGenderStats();
      this.loadRegionalData();
    },

    onTap(tab) {
      window.open(`?tab=${tab}`, "_blank");
    },

    async fetchGroupCodes() {
      if (!await this.hasRole("GURUHLAR", "READ")) {
        return;
      }

      this.codesLoading = true;
      this.codesError = null;
      try {
        const {data} = await axios.get('api/groups/get/codes'); // adjust base URL if needed

        const unique = Array.from(new Set((data || []).map(String)));
        unique.sort((a, b) => a.localeCompare(b, 'en')); // or 'uz'

        const mapped = unique.map((code, i) => ({id: i + 1, name: code}));

        this.group = [{id: 0, name: this.$t('Barchasi')}, ...mapped];

        const validIds = new Set(this.group.map(g => g.id));
        this.selectedGroup = (this.selectedGroup || []).filter(name => validIds.has(name));
      } catch (e) {
        this.codesError = e?.response?.data?.message || e.message || 'Failed to load group codes';
      } finally {
        this.codesLoading = false;
      }
    },

    // ===== API LOADERS =====
    async loadData() {
      this.loading = true;
      try {

        let res = null;
        if (this.isFiltering) {
          res = await axios.post("admin/common/get/filter", this.filters);
        } else {
          res = await axios.get("admin/common/get", { params: { studyYear: this.selectedStudyYear } });
        }

        this.stats = res.data || this.stats;

        this.lastUpdated = new Intl.DateTimeFormat("uz-UZ", {
          hour: "2-digit", minute: "2-digit", year: "numeric", month: "2-digit", day: "2-digit",
        }).format(new Date());

        // this.$nextTick(() => {
        //   this.updateOverviewCharts();
        //   this.reloadTimeseries();
        // });

        this.$nextTick(() => {
          this.updateOverviewCharts();
          if (this.charts.paymentChart?.resize) this.charts.paymentChart.resize();
          if (this.charts.groupStudentChart?.resize) this.charts.groupStudentChart.resize();
          // paymentsTrendChart is now pure HTML/CSS — no resize needed
        });


      } catch (e) {
        console.error("Error fetching dashboard data", e);
        if (this.$toast && this.$toast.error) this.$toast.error("Ma'lumotlarni yuklashda xatolik!");
      } finally {
        this.loading = false;
      }
    },

    reloadTimeseries() {
      this.ts.page = 0; // reset to latest page on reload
      if (this.isRecentYear) {
        const {from, to} = this.computeRange(this.ts.range);
        this.loadTimeseries(this.ts.bucket, from, to);
      } else {
        // For older years, load the full study year range
        const yearStart = this.selectedStudyYear.split('-')[0];
        const from = new Date(yearStart + '-09-01T00:00:00Z'); // Sep 1 of start year
        const to = new Date((parseInt(yearStart) + 1) + '-08-31T23:59:59Z'); // Aug 31 of next year
        this.loadTimeseries(this.ts.bucket, from, to);
      }
    },

    toIso(v) {
      return v instanceof Date ? v.toISOString() : v;
    },

    async loadTimeseries(bucket, from, to) {
      this.ts.loading = true;
      try {
        // Extend API 'to' to end of academic year to capture future-dated payments
        const yearEnd = this.selectedStudyYear.split('-')[1];
        const academicEnd = new Date(yearEnd + '-08-31T23:59:59Z');
        const apiTo = this.toIso(to);
        const apiFetchTo = academicEnd > new Date(apiTo) ? academicEnd.toISOString() : apiTo;

        var params = {
          bucket: bucket || 'day',
          from: this.toIso(from),
          to: apiFetchTo,
          studyYear: this.selectedStudyYear
        };

        var data;

        if (this.isFiltering) {
          // POST: filters in body, time/bucket in query params
          var resp1 = await axios.post(
              'admin/common/payments/timeseries/filter',
              this.filters || {},      // request body
              { params: params }       // ?bucket=&from=&to=
          );
          data = resp1.data;
        } else {
          // GET: only query params
          var resp2 = await axios.get(
              'admin/common/payments/timeseries',
              { params: params }
          );
          data = resp2.data;
        }

        // Build a lookup from API data keyed by date string
        const seriesMap = {};
        const cumulativeMap = {};
        (data.series || []).forEach(p => {
          const key = (p.bucket || '').substring(0, bucket === 'month' ? 7 : 10);
          seriesMap[key] = Number(p.value || 0);
        });
        (data.cumulative || []).forEach(p => {
          const key = (p.bucket || '').substring(0, bucket === 'month' ? 7 : 10);
          cumulativeMap[key] = Number(p.value || 0);
        });

        // Fill all dates/weeks/months in the from→to range (up to now only)
        const fromDate = new Date(this.toIso(from));
        const toDate = new Date(this.toIso(to));
        const dates = [];
        const labels = [];
        const series = [];
        const cumulative = [];
        let runningSum = 0;

        const d = new Date(fromDate);
        while (d <= toDate) {
          let key, label;
          if (bucket === 'month') {
            key = d.toISOString().substring(0, 7); // "2026-06"
            label = key;
            d.setMonth(d.getMonth() + 1);
          } else if (bucket === 'week') {
            key = d.toISOString().substring(0, 10); // "2026-06-02"
            label = key.substring(5);
            d.setDate(d.getDate() + 7);
          } else {
            key = d.toISOString().substring(0, 10);
            label = key.substring(5);
            d.setDate(d.getDate() + 1);
          }
          const val = seriesMap[key] || 0;
          runningSum += val;
          dates.push(key);
          labels.push(label);
          series.push(val);
          cumulative.push(cumulativeMap[key] || runningSum);
        }

        this.ts.dates = dates;
        this.ts.labels = labels;
        this.ts.series = series;
        this.ts.cumulative = cumulative;
      } catch (e) {
        console.error("Timeseries load error", e);
        if (this.$toast && this.$toast.error) this.$toast.error("To'lovlar trendini yuklashda xatolik!");
      } finally {
        this.ts.loading = false;
      }
    },

    // ===== FORMATTERS =====
    formatMoney(value) {
      const v = Number(value || 0);
      return new Intl.NumberFormat("uz-UZ").format(v) + " so'm";
    },

    formatInt(value) {
      const v = Number(value || 0);
      return new Intl.NumberFormat("uz-UZ").format(v);
    },

    // ===== OVERVIEW CHARTS =====
    updateOverviewCharts() {
      // destroy old if any
      if (this.charts.paymentChart) this.charts.paymentChart.destroy();
      if (this.charts.groupStudentChart) this.charts.groupStudentChart.destroy();

      const doughnutOpts = isV3
          ? {
            responsive: true, maintainAspectRatio: false,
            cutout: '72%',
            plugins: {
              legend: {
                position: "bottom",
                labels: {
                  color: "#6b7280",
                  font: { size: 12, family: "-apple-system, BlinkMacSystemFont, sans-serif", weight: '500' },
                  usePointStyle: true,
                  pointStyle: 'circle',
                  padding: 20,
                },
              },
              tooltip: {
                backgroundColor: '#1f2937',
                titleFont: { size: 12, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                bodyFont: { size: 13, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                padding: { top: 10, bottom: 10, left: 14, right: 14 },
                cornerRadius: 10,
                displayColors: true,
                boxPadding: 6,
                callbacks: { label: (ctx) => ' ' + new Intl.NumberFormat("uz-UZ").format(ctx.parsed) + " so'm" },
              },
            },
          }
          : {
            responsive: true, maintainAspectRatio: false,
            cutoutPercentage: 72,
            animation: {animateScale: true, animateRotate: true},
            legend: {position: "bottom", labels: {fontSize: 12, fontColor: "#6b7280", usePointStyle: true, padding: 20}},
            tooltips: {
              backgroundColor: '#1f2937', cornerRadius: 10, xPadding: 14, yPadding: 10,
              callbacks: {
                label: (ti, data) => {
                  const val = data.datasets[ti.datasetIndex].data[ti.index] || 0;
                  return ' ' + new Intl.NumberFormat("uz-UZ").format(val) + " so'm";
                },
              },
            },
          };

      // SAFE: use getCtx for paymentChart
      const paymentCtx = this.getCtx('paymentChart');
      if (paymentCtx) {
        this.charts.paymentChart = new Chart(paymentCtx, {
          type: "doughnut",
          data: {
            labels: [this.$t("To'langan"), this.$t("To'lanishi kerak")],
            datasets: [{
              data: [this.stats.paidAmount, this.stats.payableAmount],
              backgroundColor: ["#43A047", "#e53935"],
              hoverBackgroundColor: ["#2E7D32", "#c62828"],
              borderWidth: 0,
              hoverOffset: 6,
              borderRadius: 4,
              spacing: 2,
            }],
          },
          options: doughnutOpts,
        });
      }

      const barOpts = isV3
          ? {
            responsive: true, maintainAspectRatio: false,
            plugins: {
              legend: {display: false},
              tooltip: {
                backgroundColor: '#1f2937',
                titleFont: { size: 12, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                bodyFont: { size: 13, family: "-apple-system, BlinkMacSystemFont, sans-serif" },
                padding: { top: 10, bottom: 10, left: 14, right: 14 },
                cornerRadius: 10,
                boxPadding: 6,
                callbacks: {label: (ctx) => " " + this.formatInt(ctx.parsed.y) + " ta"}
              }
            },
            scales: {
              x: { grid: {display: false}, ticks: { color: '#9ca3af', font: { size: 12, family: "-apple-system, BlinkMacSystemFont, sans-serif", weight: '500' } } },
              y: { beginAtZero: true, grid: {color: "rgba(0,0,0,0.04)", drawBorder: false}, ticks: { color: '#9ca3af', font: { size: 11 }, padding: 8 }, border: { display: false } },
            },
          }
          : {
            responsive: true, maintainAspectRatio: false,
            legend: {display: false},
            scales: {
              xAxes: [{gridLines: {display: false}, ticks: { fontColor: '#9ca3af', fontSize: 12 }}],
              yAxes: [{ticks: {beginAtZero: true, fontSize: 11, fontColor: '#9ca3af', padding: 8}, gridLines: {color: "rgba(0,0,0,0.04)", drawBorder: false}}],
            },
            tooltips: {backgroundColor: '#1f2937', cornerRadius: 10, xPadding: 14, yPadding: 10, callbacks: {label: (ti) => ` ${this.formatInt(ti.yLabel)} ta`}},
          };

      // SAFE: use getCtx for groupStudentChart
      const groupCtx = this.getCtx('groupStudentChart');
      if (groupCtx) {
        this.charts.groupStudentChart = new Chart(groupCtx, {
          type: "bar",
          data: {
            labels: ["Guruhlar", "Talabalar"],
            datasets: [{
              label: "Soni",
              data: [this.stats.groupCount, this.stats.studentCount],
              backgroundColor: ["#3b82f6", "#8b5cf6"],
              hoverBackgroundColor: ["#2563eb", "#7c3aed"],
              maxBarThickness: 80,
              borderRadius: 8,
              borderSkipped: false,
            }],
          },
          options: barOpts,
        });
      }
    },

    // updateTimeseriesChart — no longer needed, chart is pure HTML/CSS via computed tsPagedData

    fmtTickVal(v) {
      if (v >= 1e9) return (v / 1e9).toFixed(1).replace(/\.0$/, '') + 'B';
      if (v >= 1e6) return (v / 1e6).toFixed(0) + 'M';
      if (v >= 1e3) return (v / 1e3).toFixed(0) + 'K';
      return String(v);
    },

    labelFormatFor(bucket) {
      if (bucket === "day") return {day: "2-digit", month: "2-digit"};
      if (bucket === "week") return {day: "2-digit", month: "2-digit"};
      return {year: "2-digit", month: "2-digit"}; // month
    },

    computeRange(key) {
      const now = new Date();
      const to = new Date(now.toISOString());
      const from = new Date(now.toISOString());

      if (key === "last_90d") from.setDate(from.getDate() - 90);
      else if (key === "ytd") {
        from.setMonth(0, 1);
        from.setHours(0, 0, 0, 0);
      } else if (key === "last_12m") from.setMonth(from.getMonth() - 12);
      else from.setMonth(from.getMonth() - 6);

      return {from: from.toISOString(), to: to.toISOString()};
    },

    // progress bars
    cardProgress(type) {
      if (!this.paymentTotal) return 0;
      if (type === "paid") return (this.stats.paidAmount / this.paymentTotal) * 100;
      if (type === "remaining") return (this.stats.payableAmount / this.paymentTotal) * 100;
      return 0;
    },
  },

  async mounted() {
    if (!await this.hasRole("GURUHLAR", "READ")) {
      await this.$router.push("/panels");
      return;
    }

    // Fix Chart.js hover offset caused by CSS zoom+transform on .ui-scale
    ['pointermove', 'pointerdown', 'mousemove', 'mousedown'].forEach(evt => {
      this.$el.addEventListener(evt, _fixOffsetForZoom, true); // capture phase
    });

    await this.loadData();
    this.reloadTimeseries();
    await this.fetchGenderStats();
    this.loadRegionalData();
  },

  beforeDestroy() {
    // Remove zoom-fix listeners
    ['pointermove', 'pointerdown', 'mousemove', 'mousedown'].forEach(evt => {
      this.$el.removeEventListener(evt, _fixOffsetForZoom, true);
    });
    if (this.charts.paymentChart) this.charts.paymentChart.destroy();
    if (this.charts.groupStudentChart) this.charts.groupStudentChart.destroy();
    if (this.charts.genderChart) this.charts.genderChart.destroy();
    if (this.charts.regionBarChart) this.charts.regionBarChart.destroy();
    if (this._tooltipObserver) this._tooltipObserver.disconnect();
    this.removeMapScript('countrymap_config');
    this.removeMapScript('countrymap');
  },
};
</script>


<style scoped>
/* ─── Apple system font for dashboard (except stat cards & icons) ─── */
.ui-scale ::v-deep *:not(.v-icon):not(.mdi) {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display",
    "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.stat-card,
.stat-card ::v-deep * {
  font-family: 'Saira SemiCondensed', Arial, sans-serif !important;
}

/* Global 90% scale (works in Chromium via zoom, and everywhere via transform) */
.ui-scale {
  /* If you prefer pure CSS without inline style, uncomment the following:
  zoom: 0.9;
  transform: scale(0.9);
  transform-origin: top left;
  width: calc(100% / 0.9);
  */
}

.refresh-btn {
  font-weight: 600;
  padding: 8px 22px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(30, 136, 229, 0.25);
}

.stat-card {
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e6e8eb;
  transition: transform .2s, box-shadow .2s;
}
@media (max-width: 600px) {
  .stat-card {
    border-radius: 12px;
  }
  .stat-value {
    font-size: 26px !important;
  }
}

.stat-card:hover {
  border-color: #d1d5db;
}

.stat-title {
  color: #6b7280;
  letter-spacing: 1.1px;
}

.stat-title.text-caption.font-weight-bold.text-uppercase {
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
}

.stat-value {
  font-size: 36px;
  line-height: 1.1;
  font-weight: 800;
  color: #0f172a;
}

.stat-icon {
  border-radius: 12px;
  background: #f6f7f9;
  box-shadow: inset 0 0 0 1px #eef0f2;
}

/* ─── Modern Chart Cards ─── */
.chart-card {
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e6e8eb;
  padding: 24px;
  transition: box-shadow 0.2s ease;
}
@media (max-width: 600px) {
  .chart-card {
    padding: 14px;
    border-radius: 12px;
  }
}

.chart-card:hover {
  border-color: #d1d5db;
}

.chart-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
}

.chart-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}

.chart-header-row .chart-header {
  margin-bottom: 0;
}

.chart-header-icon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.chart-header-icon--gold { background: linear-gradient(135deg, #ffd451, #daa520); }

.chart-title {
  font-size: 15px;
  font-weight: 600;
  color: #1f2937;
  letter-spacing: -0.2px;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif;
}

.chart-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
@media (max-width: 600px) {
  .chart-controls {
    gap: 6px;
  }
  .chart-toggle-btn {
    padding: 4px 8px;
    font-size: 11px;
  }
  .chart-header-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.chart-toggle-group {
  display: flex;
  background: #f3f4f6;
  border-radius: 8px;
  padding: 2px;
  gap: 2px;
}

.chart-toggle-btn {
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  color: #6b7280;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  outline: none;
}

.chart-toggle-btn:focus {
  outline: none;
}

.chart-toggle-btn:hover {
  color: #374151;
  background: rgba(0, 0, 0, 0.04);
}

.chart-toggle-btn--active,
.chart-toggle-btn--active:hover {
  color: #1f2937;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.chart-toggle-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* === .chart-range-select — refined dropdown, height-matched to the
   ~32px .chart-toggle-group row (Vuetify 2.4 outlined+dense v-select).
   Vuetify's default ~40px height comes from three stacked spacers — the
   slot min-height (40px), the .v-select__selection--comma vertical margin
   (~7px), and the append-inner margin-top (~4px) — all reset below.
   Scoped CSS: internals reached via ::v-deep. Dark mode is handled by the
   .dashboard--dark .chart-range-select rules (higher specificity +
   !important) and is intentionally left untouched here. */
.chart-range-select {
  max-width: 160px;
  font-size: 12px;
}

/* Collapse the dense outlined ~40px box to a flat 32px chip on white. */
.chart-range-select ::v-deep .v-input__control {
  min-height: 32px;
}
.chart-range-select ::v-deep .v-input__slot {
  min-height: 32px !important;
  height: 32px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  background: #fff;
  box-shadow: none;
}

/* Clean 1px outline, 8px radius — identical to .chart-toggle-group. */
.chart-range-select ::v-deep fieldset {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  transition: border-color 0.15s ease;
}

/* Selections row + value text: drop the dense min-height and the ~7px comma
   margin that inflate the height; vertically center and tint the value. */
.chart-range-select ::v-deep .v-select__selections {
  min-height: 32px !important;
  line-height: normal;
  flex-wrap: nowrap;
}
.chart-range-select ::v-deep .v-select__selection,
.chart-range-select ::v-deep .v-select__selection--comma {
  margin: 0;
  padding: 0;
  font-size: 12px;
  line-height: 1;
  color: #374151;
  align-self: center;
}
.chart-range-select ::v-deep input {
  margin: 0;
  padding: 0;
  line-height: 1;
}

/* Chevron column: drop dense's margin-top so it stays centered; shrink the
   default ~24px mdi-menu-down to a muted 18px (Vuetify still rotates it on
   open — the transform transition just smooths that flip). */
.chart-range-select ::v-deep .v-input__append-inner {
  margin-top: 0 !important;
  align-self: center;
  display: flex;
  align-items: center;
  padding-left: 4px;
}
.chart-range-select ::v-deep .v-input__icon--append {
  height: 18px;
  width: 18px;
  min-width: 18px;
}
.chart-range-select ::v-deep .v-input__icon--append .v-icon {
  font-size: 18px;
  color: #9ca3af;
  transition: color 0.15s ease, transform 0.15s ease;
}

/* Calm hover/focus — a slightly darker gray border, never Vuetify's 2px
   primary ring (the scoped (0,3,1) selectors out-rank Vuetify's (0,2,1)). */
.chart-range-select:hover ::v-deep fieldset {
  border-color: #d1d5db;
}
.chart-range-select:hover ::v-deep .v-input__icon--append .v-icon {
  color: #6b7280;
}
.chart-range-select.v-input--is-focused ::v-deep fieldset {
  border: 1px solid #d1d5db;
  box-shadow: none;
}

/* Disabled (e.g. during ts.loading) — fade like .chart-toggle-btn:disabled. */
.chart-range-select.v-input--is-disabled ::v-deep fieldset {
  border-color: #e5e7eb;
}
.chart-range-select.v-input--is-disabled {
  opacity: 0.5;
}

.chart-refresh-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
  outline: none;
}

.chart-refresh-btn:focus {
  outline: none;
}

.chart-refresh-btn:hover {
  background: #f9fafb;
  color: #374151;
  border-color: #d1d5db;
}

.chart-refresh-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chart-wrapper {
  position: relative;
  height: 320px;
}

.chart-wrapper--lg {
  height: 440px;
}

/* Timeseries pager */
.ts-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 10px 0 2px;
}
.ts-pager-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: rgba(0,0,0,0.04);
  color: #6b7280;
  cursor: pointer;
  transition: all 0.18s;
}
.ts-pager-btn:hover:not(:disabled) {
  background: rgba(0,0,0,0.08);
  color: #111827;
}
.ts-pager-btn:active:not(:disabled) {
  transform: scale(0.92);
}
.ts-pager-btn:disabled {
  opacity: 0.2;
  cursor: default;
}
.ts-pager-label {
  font-size: 12px;
  font-weight: 600;
  color: #9ca3af;
  letter-spacing: 0.01em;
  user-select: none;
}
.dashboard--dark .ts-pager-btn {
  background: rgba(255,255,255,0.05);
  color: #6b7280;
}
.dashboard--dark .ts-pager-btn:hover:not(:disabled) {
  background: rgba(255,255,255,0.1);
  color: #e4e5eb;
}
.dashboard--dark .ts-pager-label {
  color: #6b7280;
}

/* ── Hand-built chart ── */
.ts-chart-area {
  display: flex;
  position: relative;
  height: 440px;
  width: 100%;
  padding: 16px 14px 0 0;
}
@media (max-width: 600px) {
  .ts-chart-area {
    height: 300px;
    padding: 8px 4px 0 0;
  }
}
.ts-chart-area .fill { height: 100%; width: 100%; }
.ts-y-axis {
  position: relative;
  width: 70px;
  flex-shrink: 0;
  border-right: none;
}
@media (max-width: 600px) {
  .ts-y-axis {
    width: 45px;
  }
  .ts-y-tick {
    font-size: 9px;
  }
}
.ts-y-tick {
  position: absolute;
  right: 8px;
  transform: translateY(50%);
  font-size: 11px;
  font-weight: 500;
  color: #9ca3af;
  white-space: nowrap;
}
.ts-plot {
  flex: 1;
  position: relative;
  display: flex;
  align-items: flex-end;
  padding-bottom: 52px;
  padding-right: 6px;
  gap: 3px;
  overflow: visible;
}
.ts-grid-line {
  position: absolute;
  left: 0; right: 0;
  height: 1px;
  background: rgba(0,0,0,0.06);
  bottom: 52px;
  pointer-events: none;
}
.ts-bar-col {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: calc(100% - 52px);
  cursor: pointer;
}
.ts-bar {
  width: 60%;
  min-width: 8px;
  max-width: 36px;
  border-radius: 5px 5px 2px 2px;
  background: linear-gradient(180deg, #14b8a6 0%, #0f766e 100%);
  transition: all 0.15s ease;
  position: relative;
}
.ts-bar--hover {
  background: linear-gradient(180deg, #2dd4bf 0%, #14b8a6 100%);
  filter: brightness(1.1);
  box-shadow: 0 0 12px rgba(20,184,166,0.3);
}
.ts-x-label {
  position: absolute;
  bottom: -44px;
  font-size: 10px;
  font-weight: 500;
  color: #9ca3af;
  white-space: nowrap;
  transform: rotate(-45deg);
  transform-origin: top center;
}
@media (max-width: 600px) {
  .ts-x-label {
    font-size: 7px;
    bottom: -36px;
  }
  .ts-plot {
    padding-bottom: 42px;
  }
  .ts-bar-col:nth-child(odd) .ts-x-label {
    display: none;
  }
}
.ts-tooltip {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 10px;
  padding: 8px 14px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.1);
  pointer-events: none;
  z-index: 20;
  white-space: nowrap;
  text-align: center;
}
.ts-tooltip-title {
  font-size: 11px;
  font-weight: 500;
  color: #6b7280;
  margin-bottom: 2px;
}
.ts-tooltip-value {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

/* Dark mode overrides */
.dashboard--dark .ts-y-tick { color: #6b7280; }
.dashboard--dark .ts-grid-line { background: rgba(255,255,255,0.08); }
.dashboard--dark .ts-bar {
  background: linear-gradient(180deg, #2dd4bf 0%, #0d9488 100%);
}
.dashboard--dark .ts-bar--hover {
  background: linear-gradient(180deg, #5eead4 0%, #2dd4bf 100%);
  box-shadow: 0 0 16px rgba(45,212,191,0.3);
}
.dashboard--dark .ts-x-label { color: #6b7280; }
.dashboard--dark .ts-tooltip {
  background: #1e2030;
  border-color: #2a2c3a;
  box-shadow: 0 8px 24px rgba(0,0,0,0.4);
}
.dashboard--dark .ts-tooltip-title { color: #8b8d9e; }
.dashboard--dark .ts-tooltip-value { color: #e4e5eb; }

/* ── Line chart ── */
.ts-plot--line {
  position: relative;
  gap: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 4px !important; /* no x-labels, minimal bottom */
}
.ts-plot--line .ts-grid-line {
  bottom: 4px;
}
.ts-line-svg {
  position: absolute;
  top: 0; left: 0; right: 0;
  bottom: 4px;
  width: 100%;
  height: calc(100% - 4px);
  pointer-events: none;
  z-index: 1;
  overflow: visible;
}

/* Dot layer — identical box to SVG so % coords match exactly */
.ts-dot-layer {
  position: absolute;
  top: 0; left: 0; right: 0;
  bottom: 4px;
  pointer-events: none;
  z-index: 3;
}
.ts-dot {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #14b8a6;
  border: 2.5px solid #fff;
  transform: translate(-50%, 50%);
  transition: all 0.18s ease;
  box-shadow: 0 1px 4px rgba(0,0,0,0.12);
  opacity: 0; /* hidden by default */
}
.ts-dot--hover {
  opacity: 1; /* visible on hover */
  width: 13px;
  height: 13px;
  background: #2dd4bf;
  border-color: #fff;
  box-shadow: 0 0 14px rgba(20,184,166,0.45);
  transform: translate(-50%, 50%);
  z-index: 4;
}

/* Hover columns — invisible, just for mouse interaction */
.ts-line-col {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: calc(100% - 4px);
  cursor: pointer;
  z-index: 5;
}
.ts-line-col .ts-tooltip {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

/* Line chart — dark mode */
.dashboard--dark .ts-dot {
  background: #2dd4bf;
  border-color: #1e2030;
  box-shadow: 0 1px 6px rgba(0,0,0,0.3);
}
.dashboard--dark .ts-dot--hover {
  background: #5eead4;
  border-color: #1e2030;
  box-shadow: 0 0 18px rgba(45,212,191,0.45);
}
.dashboard--dark .ts-line-svg polyline {
  stroke: #2dd4bf;
}

/* Toggle button with icon + text */
.chart-toggle-btn .v-icon {
  vertical-align: middle;
  color: inherit !important;
}

.chart-wrapper .fill {
  height: 100%;
}

.text--secondary {
  color: #6b7280 !important;
}

@media only screen and (max-width: 1280px) {
  .stat-value {
    font-size: 32px;
  }
}

/* ══════════════════════════════════════════════════════════════
   DARK MODE — Claude-inspired soft dark
   Uses .dashboard--dark class toggled via $vuetify.theme.dark
   Palette: #111318 / #1a1b23 / #22232e / #2a2c3a / #33354a
   Accent: #ffd451
   ══════════════════════════════════════════════════════════════ */

/* ── Stat Cards ── */
.dashboard--dark .stat-card {
  background: #1a1b23 !important;
  border-color: #2a2c3a !important;
}

.dashboard--dark .stat-card:hover {
  border-color: #33354a !important;
}

.dashboard--dark .stat-value {
  color: #e4e5eb;
}

.dashboard--dark .stat-title {
  color: #8b8d9e;
}

.dashboard--dark .stat-icon {
  background: #22232e;
  box-shadow: inset 0 0 0 1px #33354a;
}

/* ── Chart Cards ── */
.dashboard--dark .chart-card {
  background: #1a1b23;
  border-color: #2a2c3a;
}

.dashboard--dark .chart-card:hover {
  border-color: #33354a;
}

.dashboard--dark .chart-title {
  color: #e4e5eb;
}

/* ── Chart Toggle Buttons ── */
.dashboard--dark .chart-toggle-group {
  background: #111318;
}

.dashboard--dark .chart-toggle-btn {
  color: #8b8d9e;
}

.dashboard--dark .chart-toggle-btn:hover {
  color: #e4e5eb;
  background: rgba(255, 255, 255, 0.05);
}

.dashboard--dark .chart-toggle-btn--active,
.dashboard--dark .chart-toggle-btn--active:hover {
  color: #111318;
  background: #ffd451;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
}
.dashboard--dark .chart-toggle-btn--active .v-icon {
  color: #111318 !important;
}

/* ── Chart Refresh Button ── */
.dashboard--dark .chart-refresh-btn {
  background: #1a1b23;
  border-color: #2a2c3a;
  color: #8b8d9e;
}

.dashboard--dark .chart-refresh-btn:hover {
  background: #22232e;
  color: #e4e5eb;
  border-color: #33354a;
}

/* ── Chart Range Select (Vuetify v-select) ── */
.dashboard--dark .chart-range-select ::v-deep .v-input__slot {
  background: #1a1b23 !important;
}

.dashboard--dark .chart-range-select ::v-deep fieldset {
  border-color: #2a2c3a !important;
}

.dashboard--dark .chart-range-select ::v-deep .v-select__selection {
  color: #e4e5eb !important;
}

.dashboard--dark .chart-range-select ::v-deep .v-icon {
  color: #8b8d9e !important;
}

/* ── Progress Bars ── */
.dashboard--dark ::v-deep .v-progress-linear__background {
  background-color: #2a2c3a !important;
}

/* ── Skeleton Loaders ── */
.dashboard--dark ::v-deep .v-skeleton-loader__image,
.dashboard--dark ::v-deep .v-skeleton-loader__heading,
.dashboard--dark ::v-deep .v-skeleton-loader__text {
  background: #22232e !important;
}

/* ── Regional Map ── */
.region-map-wrapper {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  overflow: visible;
  background: transparent;
}

.dashboard--dark .region-map-wrapper {
  background: #1a1b23;
}

.region-map-loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
}

.map_uzb {
  width: 100%;
  margin: 0 auto;
  padding-top: 10px;
}

.region-bar-chart-wrapper {
  position: relative;
  width: 100%;
  height: 520px;
  padding: 8px 16px 8px 0;
}

/* ── Secondary text ── */
.dashboard--dark .text--secondary {
  color: #8b8d9e !important;
}

/* ── V-select / V-menu dropdown cards ── */
.dashboard--dark ::v-deep .v-card {
  background-color: #1a1b23 !important;
}

.dashboard--dark ::v-deep .v-card .v-card__title {
  color: #e4e5eb;
}

.dashboard--dark ::v-deep .v-card .v-card__text {
  color: #b0b2be;
}

.dashboard--dark ::v-deep .v-divider {
  border-color: #2a2c3a !important;
}

/* ── V-checkbox labels ── */
.dashboard--dark ::v-deep .v-label {
  color: #b0b2be !important;
}

.dashboard--dark ::v-deep .v-input--checkbox .v-icon {
  color: #606275 !important;
}

.dashboard--dark ::v-deep .v-input--is-label-active .v-icon {
  color: #ffd451 !important;
}

/* ── V-text-field (search inputs in dropdowns) ── */
.dashboard--dark ::v-deep .v-text-field > .v-input__control > .v-input__slot::before {
  border-color: #33354a !important;
}

.dashboard--dark ::v-deep .v-text-field input {
  color: #e4e5eb !important;
}

.dashboard--dark ::v-deep .v-text-field .v-label {
  color: #606275 !important;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.filter-row > * {
  flex: 0 1 calc(33.333% - 11px);
  min-width: 0;
  width: calc(33.333% - 11px);
}

.filter-row ::v-deep .button-primary {
  width: 100%;
}

.study-year-title {
  font-weight: 700;
  font-size: 15px;
  color: #0f172a;
  white-space: nowrap;
  letter-spacing: 0.3px;
}
@media (max-width: 600px) {
  .study-year-title {
    font-size: 12px;
  }
}

.dashboard--dark .study-year-title {
  color: #e4e5eb;
}

@media (max-width: 600px) {
  .filter-row > * { flex: 1 1 calc(50% - 8px); width: calc(50% - 8px); }
}

</style>

<style lang="scss" scoped>
.card-title {
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.527);

  margin-bottom: 20px;
  padding-bottom: 10px;

  font-weight: 500;
  font-size: 18px;

  text-transform: uppercase;

  text-align: center;
}

.card-count {
  font-size: 24px;
  font-weight: 500;

  color: white;

  text-align: center;
}

.card-table {
  width: 100%;
  box-shadow: 0px 2px 4px rgba(128, 128, 128, 0.267);
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.right-form {
  padding: 15px 15px 10px 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.right-form div {
  width: 300px;
  height: 60px;
}

._cards-wrap {
  @media only screen and (max-width: 1200px) {
    > div {
      margin: 20px 0;
    }
  }

  @media only screen and (min-width: 1200px) {
    display: flex;
    justify-content: space-between;
    > div {
      flex: 1;
      margin-left: 20px;

      &:first-child {
        margin-left: 0;
      }
    }
  }
}

.v-btn:not(.v-btn--round).v-size--default {
  height: 36px;
  min-width: calc(100% / 3 - 16px);
  padding: 0 16px;
}

.v-menu__content.theme--light.menuable__content__active {
  background: #FFF;
}

// .v-input.v-input--hide-details.v-input--dense.theme--light.v-text-field.v-text-field--is-booted {
//     display: block;
//   min-width: 100%;
// }
// .v-card__title {
//   display: block;
//   min-width: 100%;

// }
.button-primary {
  background-color: #ffffff;
  border: 1px solid #d0d5dd;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 10px;
  transition: all 0.15s ease-in-out;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
  cursor: pointer;
  text-transform: none;
}

.button-primary:hover {
  background-color: #f9fafb;
  border-color: #c0c7d0;
}

.button-primary:active {
  background-color: #f0f2f5;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}

.button-primary--selected {
  background-color: #2e90fa;
  border-color: #2e90fa;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.filter-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: #f5f5f5 !important;
  color: #f5f5f5;
  font-size: 15px;
  font-weight: 500;
  padding: 10px 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: none;
  border: 1px solid #d0d5dd;
  text-transform: uppercase;
  min-width: 10px !important;
  border-radius: 20px;
  padding: 0 12.555556px !important;
}

.filter-btn img {
  width: 20px;
  height: 20px;
  object-fit: cover;
  margin-right: 0 !important;
}

.filter-btn:hover {
  background-color: #1570ef;
}

.filter-btn:active {
  background-color: #175cd3;
  transform: scale(0.97);
}

.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}

// restyling
$radius: 14px;
$gap: 14px;
$line: #e6e8ec;
$ink: #0f172a;
$muted: #667085;

/* royal accents */
$royal-blue: #3451e6; // All
$imperial-red: #c81e1e; // Not paid
$amber-gold: #b88300; // Half paid
$emerald: #148b4b; // Paid

.royal-row {
  padding: 8px 12px;
}

.royal-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: $gap;
  @media (max-width: 1280px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
}

.royal-card {
  position: relative;
  overflow: hidden; /* keep stripe inside radius */
  cursor: pointer;
  background: #fff;
  border: 1px solid $line;
  border-radius: $radius;
  padding: 16px;
  min-height: 92px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;

  transition: border-color .18s ease, transform .18s ease, background-color .18s ease;
  outline: none;

  /* full-bleed top stripe */
  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 4px;
    background: transparent;
  }

  /* subtle interactions */
  &:hover {
    transform: translateY(-1px);
    border-color: #d7d9df;
  }

  &:active {
    transform: translateY(0);
  }

  &:focus {
    outline: none;
  }

  /* hover wave */
  &::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent, rgba(0, 0, 0, .03), transparent);
    transform: translateX(-100%);
    pointer-events: none;
  }

  &:hover::after {
    animation: wave 1200ms ease;
  }

  /* initial mount reveal */
  animation: slideUpFade .38s ease both;
}

.royal-card:nth-child(1) {
  animation-delay: 40ms;
}

.royal-card:nth-child(2) {
  animation-delay: 80ms;
}

.royal-card:nth-child(3) {
  animation-delay: 120ms;
}

.royal-card:nth-child(4) {
  animation-delay: 160ms;
}

.royal-title {
  color: $muted;
  font-size: 12px;
  line-height: 1;
  letter-spacing: .08em;
  text-transform: uppercase;
  font-weight: 700;
}

.royal-count {
  color: $ink; /* stays black */
  font-weight: 900;
  font-size: clamp(24px, 3.6vw, 36px);
  line-height: 1.05;
  letter-spacing: -0.2px;
  font-variant-numeric: tabular-nums lining-nums;
}

/* ratio meter */
.royal-meter {
  height: 6px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f1f3f5;
  overflow: hidden;

  > span {
    display: block;
    height: 100%;
    width: 0%;
    transition: width .45s cubic-bezier(.2, .8, .2, 1);
  }
}

/* per-variant colors (no CSS vars) */
.royal-card.royal--all {
  &::before {
    background: $royal-blue;
  }

  .royal-meter > span {
    background: $royal-blue;
  }
}

.royal-card.royal--not {
  &::before {
    background: $imperial-red;
  }

  .royal-meter > span {
    background: $imperial-red;
  }
}

.royal-card.royal--half {
  &::before {
    background: $amber-gold;
  }

  .royal-meter > span {
    background: $amber-gold;
  }
}

.royal-card.royal--paid {
  &::before {
    background: $emerald;
  }

  .royal-meter > span {
    background: $emerald;
  }
}

/* animations */
@keyframes wave {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes slideUpFade {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* reduced motion */
@media (prefers-reduced-motion: reduce) {
  .royal-card,
  .royal-meter > span {
    transition: none;
    animation: none;
  }
}

/* ══════════════════════════════════════════════════════════════
   DARK MODE — Royal cards, filters, buttons (SCSS block)
   Claude-inspired soft palette with #ffd451 accent
   ══════════════════════════════════════════════════════════════ */

/* ── Royal Cards ── */
.dashboard--dark .royal-card {
  background: #1a1b23;
  border-color: #2a2c3a;

  &:hover {
    border-color: #33354a;
    transform: translateY(-1px);
  }

  &::after {
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, .02), transparent);
  }
}

.dashboard--dark .royal-title {
  color: #8b8d9e;
}

.dashboard--dark .royal-count {
  color: #e4e5eb;
}

.dashboard--dark .royal-meter {
  background: #22232e;
}

/* ── Filter Button ── */
.dashboard--dark .filter-btn {
  background-color: #1a1b23 !important;
  border-color: #2a2c3a !important;
  color: #e4e5eb !important;

  &:hover {
    background-color: #22232e !important;
  }

  img {
    filter: brightness(0) invert(1);
    opacity: 0.7;
  }
}

/* ── Button Primary (dropdown triggers) ── */
.dashboard--dark .button-primary {
  background-color: #1a1b23 !important;
  border-color: #2a2c3a !important;
  color: #e4e5eb !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);

  &:hover {
    background-color: #22232e !important;
    border-color: #33354a !important;
  }

  &:active {
    background-color: #111318 !important;
  }
}

.dashboard--dark .button-primary--selected {
  background-color: #ffd451 !important;
  border-color: #ffd451 !important;
  color: #111318 !important;
}

/* ── V-menu card overrides (scss scope) ── */
.dashboard--dark ::v-deep .v-menu__content {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4) !important;
}

.dashboard--dark ::v-deep .v-btn--text {
  color: #8b8d9e !important;

  &:hover {
    color: #e4e5eb !important;
  }
}

/* ── V-card outlined override ── */
.dashboard--dark ::v-deep .v-card--outlined {
  border-color: #2a2c3a !important;
}

/* ── Smooth transitions ── */
.stat-card,
.chart-card,
.royal-card,
.filter-btn,
.button-primary,
.chart-toggle-group,
.chart-toggle-btn,
.chart-refresh-btn {
  transition: background-color 0.2s ease, border-color 0.2s ease,
    color 0.2s ease, box-shadow 0.2s ease;
}

</style>

<!-- Non-scoped: SimpleMap tooltip is injected at document level -->
<style>
/* ── SimpleMap Tooltip (always dark) ── */
#tt_sm_map {
  z-index: 9999 !important;
  background: #1e2030 !important;
  color: #e4e5eb !important;
  border: 1px solid #2a2c3a !important;
  border-radius: 10px !important;
  padding: 0 !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5) !important;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display",
    "SF Pro Text", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-size: 13px !important;
  line-height: 1.6 !important;
  min-width: 140px !important;
  pointer-events: none;
  overflow: hidden;
}
#tt_sm_map .tt_sm {
  background: #1e2030 !important;
  color: #e4e5eb !important;
  padding: 10px 16px !important;
  border-radius: 10px !important;
  box-shadow: none !important;
}
#tt_sm_map .tt_name_sm_map {
  font-weight: 600 !important;
  font-size: 13px !important;
  color: #ffffff !important;
  margin-bottom: 4px !important;
  display: block;
}
#tt_sm_map .tt_custom_sm_map {
  font-weight: 700 !important;
  font-size: 20px !important;
  color: #FFD700 !important;
  display: block;
}

/* ── Ensure tooltip can overflow above map container ── */
#map,
#map_holder,
#map_inner {
  overflow: visible !important;
  position: relative;
}
#map svg {
  position: relative;
  z-index: 0;
}
</style>